function PlanBB({ ...props }) {
	return (
		<g {...props} id="unit-bb">
			<g id="furniture">
				<polyline
					points="260.13 685.24 255.88 685.24 255.88 683.09 260.13 683.09 260.13 685.24"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="314.77 433.53 314.77 680.94 267.45 680.94 267.45 433.53 314.77 433.53"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="529.58 469 529.58 604.53 559.16 604.53 559.16 469 529.58 469"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="559.16"
					y1="469"
					x2="529.58"
					y2="469"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="559.16"
					y1="604.53"
					x2="559.16"
					y2="469"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="604.53"
					x2="559.16"
					y2="604.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="469"
					x2="529.58"
					y2="604.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="469"
					x2="529.58"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="473.83"
					x2="529.58"
					y2="478.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="481.4"
					x2="529.58"
					y2="486.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="488.97"
					x2="529.58"
					y2="493.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="496.54"
					x2="529.58"
					y2="501.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="504.12"
					x2="529.58"
					y2="508.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="511.69"
					x2="529.58"
					y2="516.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="519.26"
					x2="529.58"
					y2="523.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="526.83"
					x2="529.58"
					y2="531.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="534.4"
					x2="529.58"
					y2="539.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="541.97"
					x2="529.58"
					y2="546.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="549.54"
					x2="529.58"
					y2="554.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="557.11"
					x2="529.58"
					y2="561.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="564.68"
					x2="529.58"
					y2="569.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="572.25"
					x2="529.58"
					y2="576.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="579.82"
					x2="529.58"
					y2="584.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="587.39"
					x2="529.58"
					y2="592.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="594.96"
					x2="529.58"
					y2="599.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="602.53"
					x2="529.58"
					y2="604.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="604.53"
					x2="534.39"
					y2="604.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.23"
					y1="604.53"
					x2="541.97"
					y2="604.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.8"
					y1="604.53"
					x2="549.54"
					y2="604.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="552.38"
					y1="604.53"
					x2="557.18"
					y2="604.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.18"
					y1="604.53"
					x2="557.18"
					y2="602.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.18"
					y1="599.7"
					x2="557.18"
					y2="594.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.18"
					y1="592.12"
					x2="557.18"
					y2="587.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.18"
					y1="584.55"
					x2="557.18"
					y2="579.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.18"
					y1="576.98"
					x2="557.18"
					y2="572.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.18"
					y1="569.41"
					x2="557.18"
					y2="564.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.18"
					y1="561.84"
					x2="557.18"
					y2="557.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.18"
					y1="554.27"
					x2="557.18"
					y2="549.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.18"
					y1="546.7"
					x2="557.18"
					y2="541.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.18"
					y1="539.13"
					x2="557.18"
					y2="534.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.18"
					y1="531.56"
					x2="557.18"
					y2="526.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.18"
					y1="523.99"
					x2="557.18"
					y2="519.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.18"
					y1="516.42"
					x2="557.18"
					y2="511.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.18"
					y1="508.85"
					x2="557.18"
					y2="504.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.18"
					y1="501.28"
					x2="557.18"
					y2="496.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.18"
					y1="493.71"
					x2="557.18"
					y2="488.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.18"
					y1="486.13"
					x2="557.18"
					y2="481.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.18"
					y1="478.56"
					x2="557.18"
					y2="473.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.18"
					y1="470.99"
					x2="557.18"
					y2="469"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.18"
					y1="469"
					x2="552.38"
					y2="469"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="549.54"
					y1="469"
					x2="544.8"
					y2="469"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.97"
					y1="469"
					x2="537.23"
					y2="469"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.39"
					y1="469"
					x2="529.58"
					y2="469"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="248.57 762.91 297.29 762.91 297.29 811.63 248.57 811.63 248.57 762.91"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="190.01 172.96 190.01 174.93 121.12 174.93 121.12 172.96 190.01 172.96"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="190.01"
					y1="172.96"
					x2="190.01"
					y2="174.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="190.01"
					y1="174.93"
					x2="121.12"
					y2="174.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="121.12"
					y1="174.93"
					x2="121.12"
					y2="172.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="121.12"
					y1="172.96"
					x2="190.01"
					y2="172.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="229.07 172.19 197.03 172.19 197.03 176.45 229.07 176.45 229.07 172.19"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="195.48 171.8 230.62 171.8 230.62 172.19 195.48 172.19 195.48 171.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="195.48"
					y1="171.8"
					x2="230.62"
					y2="171.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="230.62"
					y1="171.8"
					x2="230.62"
					y2="172.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="230.62"
					y1="172.19"
					x2="195.48"
					y2="172.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.48"
					y1="172.19"
					x2="195.48"
					y2="171.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="229.07"
					y1="176.45"
					x2="197.03"
					y2="176.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.03"
					y1="172.19"
					x2="229.07"
					y2="172.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="232.57 176.45 229.07 176.45 229.07 172.19 232.57 172.19 232.57 176.45"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="232.57"
					y1="176.45"
					x2="229.07"
					y2="176.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="229.07"
					y1="176.45"
					x2="229.07"
					y2="172.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="229.07"
					y1="172.19"
					x2="232.57"
					y2="172.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="232.57"
					y1="172.19"
					x2="232.57"
					y2="176.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="193.54 172.19 197.03 172.19 197.03 176.45 193.54 176.45 193.54 172.19"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="193.54"
					y1="172.19"
					x2="197.03"
					y2="172.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.03"
					y1="172.19"
					x2="197.03"
					y2="176.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.03"
					y1="176.45"
					x2="193.54"
					y2="176.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.54"
					y1="176.45"
					x2="193.54"
					y2="172.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="229.07"
					y1="172.96"
					x2="197.03"
					y2="172.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="234.12 176.07 232.57 176.07 232.57 172.19 230.62 172.19 230.62 171.8 234.12 171.8 234.12 176.07"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="234.12"
					y1="176.07"
					x2="232.57"
					y2="176.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="232.57"
					y1="176.07"
					x2="232.57"
					y2="172.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="232.57"
					y1="172.19"
					x2="230.62"
					y2="172.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="230.62"
					y1="172.19"
					x2="230.62"
					y2="171.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="230.62"
					y1="171.8"
					x2="234.12"
					y2="171.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.12"
					y1="171.8"
					x2="234.12"
					y2="176.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="191.98 171.8 195.48 171.8 195.48 172.19 193.54 172.19 193.54 176.07 191.98 176.07 191.98 171.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="191.98"
					y1="171.8"
					x2="195.48"
					y2="171.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.48"
					y1="171.8"
					x2="195.48"
					y2="172.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.48"
					y1="172.19"
					x2="193.54"
					y2="172.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.54"
					y1="172.19"
					x2="193.54"
					y2="176.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.54"
					y1="176.07"
					x2="191.98"
					y2="176.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.98"
					y1="176.07"
					x2="191.98"
					y2="171.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="119.15 172.96 123.09 172.96 123.09 184.79 119.15 184.79 119.15 172.96"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="123.09"
					y1="172.96"
					x2="119.15"
					y2="172.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="123.09"
					y1="184.79"
					x2="123.09"
					y2="172.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="119.15"
					y1="184.79"
					x2="123.09"
					y2="184.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="119.15"
					y1="172.96"
					x2="119.15"
					y2="184.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="188.04 172.96 191.98 172.96 191.98 184.79 188.04 184.79 188.04 172.96"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="191.98"
					y1="172.96"
					x2="188.04"
					y2="172.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.98"
					y1="184.79"
					x2="191.98"
					y2="172.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.04"
					y1="184.79"
					x2="191.98"
					y2="184.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.04"
					y1="172.96"
					x2="188.04"
					y2="184.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="238.06 172.96 238.06 184.79 234.12 184.79 234.12 172.96 238.06 172.96"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="238.06"
					y1="184.79"
					x2="238.06"
					y2="172.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.12"
					y1="184.79"
					x2="238.06"
					y2="184.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.12"
					y1="172.96"
					x2="234.12"
					y2="184.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.06"
					y1="172.96"
					x2="234.12"
					y2="172.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="426.91 172.96 426.91 174.93 344.9 174.93 344.9 172.96 426.91 172.96"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="426.91"
					y1="172.96"
					x2="426.91"
					y2="174.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="426.91"
					y1="174.93"
					x2="344.9"
					y2="174.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="344.9"
					y1="174.93"
					x2="344.9"
					y2="172.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="344.9"
					y1="172.96"
					x2="426.91"
					y2="172.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="465.5 172.19 433.93 172.19 433.93 176.45 465.5 176.45 465.5 172.19"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="432.38 171.8 467.05 171.8 467.05 172.19 432.38 172.19 432.38 171.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="432.38"
					y1="171.8"
					x2="467.05"
					y2="171.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.05"
					y1="171.8"
					x2="467.05"
					y2="172.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.05"
					y1="172.19"
					x2="432.38"
					y2="172.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.38"
					y1="172.19"
					x2="432.38"
					y2="171.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="465.5"
					y1="176.45"
					x2="433.93"
					y2="176.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.93"
					y1="172.19"
					x2="465.5"
					y2="172.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="468.99 176.45 465.5 176.45 465.5 172.19 468.99 172.19 468.99 176.45"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="468.99"
					y1="176.45"
					x2="465.5"
					y2="176.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="465.5"
					y1="176.45"
					x2="465.5"
					y2="172.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="465.5"
					y1="172.19"
					x2="468.99"
					y2="172.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.99"
					y1="172.19"
					x2="468.99"
					y2="176.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="430.44 172.19 433.93 172.19 433.93 176.45 430.44 176.45 430.44 172.19"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="430.44"
					y1="172.19"
					x2="433.93"
					y2="172.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.93"
					y1="172.19"
					x2="433.93"
					y2="176.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.93"
					y1="176.45"
					x2="430.44"
					y2="176.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.44"
					y1="176.45"
					x2="430.44"
					y2="172.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="465.5"
					y1="172.96"
					x2="433.93"
					y2="172.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="470.54 176.07 468.99 176.07 468.99 172.19 467.05 172.19 467.05 171.8 470.54 171.8 470.54 176.07"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="470.54"
					y1="176.07"
					x2="468.99"
					y2="176.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.99"
					y1="176.07"
					x2="468.99"
					y2="172.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.99"
					y1="172.19"
					x2="467.05"
					y2="172.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.05"
					y1="172.19"
					x2="467.05"
					y2="171.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.05"
					y1="171.8"
					x2="470.54"
					y2="171.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="470.54"
					y1="171.8"
					x2="470.54"
					y2="176.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="428.89 171.8 432.38 171.8 432.38 172.19 430.44 172.19 430.44 176.07 428.89 176.07 428.89 171.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="428.89"
					y1="171.8"
					x2="432.38"
					y2="171.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.38"
					y1="171.8"
					x2="432.38"
					y2="172.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.38"
					y1="172.19"
					x2="430.44"
					y2="172.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.44"
					y1="172.19"
					x2="430.44"
					y2="176.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.44"
					y1="176.07"
					x2="428.89"
					y2="176.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.89"
					y1="176.07"
					x2="428.89"
					y2="171.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="424.94 172.96 428.89 172.96 428.89 184.79 424.94 184.79 424.94 172.96"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="428.89"
					y1="172.96"
					x2="424.94"
					y2="172.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.89"
					y1="184.79"
					x2="428.89"
					y2="172.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.94"
					y1="184.79"
					x2="428.89"
					y2="184.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.94"
					y1="172.96"
					x2="424.94"
					y2="184.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="474.49 172.96 474.49 184.79 470.54 184.79 470.54 172.96 474.49 172.96"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="474.49"
					y1="184.79"
					x2="474.49"
					y2="172.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="470.54"
					y1="184.79"
					x2="474.49"
					y2="184.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="470.54"
					y1="172.96"
					x2="470.54"
					y2="184.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.49"
					y1="172.96"
					x2="470.54"
					y2="172.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="342.92 172.96 346.87 172.96 346.87 184.79 342.92 184.79 342.92 172.96"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="346.87"
					y1="172.96"
					x2="342.92"
					y2="172.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.87"
					y1="184.79"
					x2="346.87"
					y2="172.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.92"
					y1="184.79"
					x2="346.87"
					y2="184.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.92"
					y1="172.96"
					x2="342.92"
					y2="184.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="909.96 504.58 907.99 504.58 907.99 422.57 909.96 422.57 909.96 504.58"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="909.96"
					y1="504.58"
					x2="907.99"
					y2="504.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.99"
					y1="504.58"
					x2="907.99"
					y2="422.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.99"
					y1="422.57"
					x2="909.96"
					y2="422.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.96"
					y1="422.57"
					x2="909.96"
					y2="504.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="910.74 543.17 910.74 511.6 906.47 511.6 906.47 543.17 910.74 543.17"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="911.13 510.05 911.13 544.72 910.74 544.72 910.74 510.05 911.13 510.05"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="911.13"
					y1="510.05"
					x2="911.13"
					y2="544.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.13"
					y1="544.72"
					x2="910.74"
					y2="544.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.74"
					y1="544.72"
					x2="910.74"
					y2="510.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.74"
					y1="510.05"
					x2="911.13"
					y2="510.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.47"
					y1="543.17"
					x2="906.47"
					y2="511.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.74"
					y1="511.6"
					x2="910.74"
					y2="543.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="906.47 546.66 906.47 543.17 910.74 543.17 910.74 546.66 906.47 546.66"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="906.47"
					y1="546.66"
					x2="906.47"
					y2="543.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.47"
					y1="543.17"
					x2="910.74"
					y2="543.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.74"
					y1="543.17"
					x2="910.74"
					y2="546.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.74"
					y1="546.66"
					x2="906.47"
					y2="546.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="910.74 508.11 910.74 511.6 906.47 511.6 906.47 508.11 910.74 508.11"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="910.74"
					y1="508.11"
					x2="910.74"
					y2="511.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.74"
					y1="511.6"
					x2="906.47"
					y2="511.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.47"
					y1="511.6"
					x2="906.47"
					y2="508.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.47"
					y1="508.11"
					x2="910.74"
					y2="508.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.96"
					y1="543.17"
					x2="909.96"
					y2="511.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="906.86 548.22 906.86 546.66 910.74 546.66 910.74 544.72 911.13 544.72 911.13 548.22 906.86 548.22"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="906.86"
					y1="548.22"
					x2="906.86"
					y2="546.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.86"
					y1="546.66"
					x2="910.74"
					y2="546.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.74"
					y1="546.66"
					x2="910.74"
					y2="544.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.74"
					y1="544.72"
					x2="911.13"
					y2="544.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.13"
					y1="544.72"
					x2="911.13"
					y2="548.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.13"
					y1="548.22"
					x2="906.86"
					y2="548.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="911.13 506.56 911.13 510.05 910.74 510.05 910.74 508.11 906.86 508.11 906.86 506.56 911.13 506.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="911.13"
					y1="506.56"
					x2="911.13"
					y2="510.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.13"
					y1="510.05"
					x2="910.74"
					y2="510.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.74"
					y1="510.05"
					x2="910.74"
					y2="508.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.74"
					y1="508.11"
					x2="906.86"
					y2="508.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.86"
					y1="508.11"
					x2="906.86"
					y2="506.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.86"
					y1="506.56"
					x2="911.13"
					y2="506.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="909.96 502.61 909.96 506.56 898.13 506.56 898.13 502.61 909.96 502.61"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="909.96"
					y1="506.56"
					x2="909.96"
					y2="502.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="898.13"
					y1="506.56"
					x2="909.96"
					y2="506.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="898.13"
					y1="502.61"
					x2="898.13"
					y2="506.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.96"
					y1="502.61"
					x2="898.13"
					y2="502.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="909.96 552.16 898.13 552.16 898.13 548.22 909.96 548.22 909.96 552.16"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="898.13"
					y1="552.16"
					x2="909.96"
					y2="552.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="898.13"
					y1="548.22"
					x2="898.13"
					y2="552.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.96"
					y1="548.22"
					x2="898.13"
					y2="548.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.96"
					y1="552.16"
					x2="909.96"
					y2="548.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="909.96 420.59 909.96 424.54 898.13 424.54 898.13 420.59 909.96 420.59"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="909.96"
					y1="424.54"
					x2="909.96"
					y2="420.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="898.13"
					y1="424.54"
					x2="909.96"
					y2="424.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="898.13"
					y1="420.59"
					x2="898.13"
					y2="424.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.96"
					y1="420.59"
					x2="898.13"
					y2="420.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="728.98 338.68 728.98 340.65 798.21 340.65 798.21 338.68 728.98 338.68"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="798.21"
					y1="338.68"
					x2="728.98"
					y2="338.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.21"
					y1="340.65"
					x2="798.21"
					y2="338.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="728.98"
					y1="340.65"
					x2="798.21"
					y2="340.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="728.98"
					y1="338.68"
					x2="728.98"
					y2="340.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="659.97 338.68 659.97 340.65 728.98 340.65 728.98 338.68 659.97 338.68"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="728.98"
					y1="338.68"
					x2="659.97"
					y2="338.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="728.98"
					y1="340.65"
					x2="728.98"
					y2="338.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="659.97"
					y1="340.65"
					x2="728.98"
					y2="340.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="659.97"
					y1="338.68"
					x2="659.97"
					y2="340.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="589.37 338.68 589.37 340.65 659.97 340.65 659.97 338.68 589.37 338.68"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="659.97"
					y1="338.68"
					x2="589.37"
					y2="338.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="659.97"
					y1="340.65"
					x2="659.97"
					y2="338.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.37"
					y1="340.65"
					x2="659.97"
					y2="340.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.37"
					y1="338.68"
					x2="589.37"
					y2="340.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="798.21 338.68 798.21 340.65 870.48 340.65 870.48 338.68 798.21 338.68"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="870.48"
					y1="338.68"
					x2="798.21"
					y2="338.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.48"
					y1="340.65"
					x2="870.48"
					y2="338.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.21"
					y1="340.65"
					x2="870.48"
					y2="340.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.21"
					y1="338.68"
					x2="798.21"
					y2="340.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="730.95 338.68 730.95 350.5 727 350.5 727 338.68 730.95 338.68"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="730.95"
					y1="350.5"
					x2="730.95"
					y2="338.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727"
					y1="350.5"
					x2="730.95"
					y2="350.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727"
					y1="338.68"
					x2="727"
					y2="350.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.95"
					y1="338.68"
					x2="727"
					y2="338.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="661.94 338.68 661.94 350.5 658 350.5 658 338.68 661.94 338.68"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="661.94"
					y1="350.5"
					x2="661.94"
					y2="338.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658"
					y1="350.5"
					x2="661.94"
					y2="350.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658"
					y1="338.68"
					x2="658"
					y2="350.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="661.94"
					y1="338.68"
					x2="658"
					y2="338.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="872.45 338.68 872.45 350.5 868.51 350.5 868.51 338.68 872.45 338.68"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="872.45"
					y1="350.5"
					x2="872.45"
					y2="338.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="868.51"
					y1="350.5"
					x2="872.45"
					y2="350.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="868.51"
					y1="338.68"
					x2="868.51"
					y2="350.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.45"
					y1="338.68"
					x2="868.51"
					y2="338.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="800.18 338.68 800.18 350.5 796.23 350.5 796.23 338.68 800.18 338.68"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="800.18"
					y1="350.5"
					x2="800.18"
					y2="338.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="796.23"
					y1="350.5"
					x2="800.18"
					y2="350.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="796.23"
					y1="338.68"
					x2="796.23"
					y2="350.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="800.18"
					y1="338.68"
					x2="796.23"
					y2="338.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="587.4 338.68 591.34 338.68 591.34 350.5 587.4 350.5 587.4 338.68"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="591.34"
					y1="338.68"
					x2="587.4"
					y2="338.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.34"
					y1="350.5"
					x2="591.34"
					y2="338.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.4"
					y1="350.5"
					x2="591.34"
					y2="350.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.4"
					y1="338.68"
					x2="587.4"
					y2="350.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="302.88"
					y1="745.41"
					x2="318.65"
					y2="745.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="332.01"
					y1="745.41"
					x2="318.65"
					y2="745.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="332.01"
					y1="680.94"
					x2="332.01"
					y2="745.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="913.91"
					y1="552.16"
					x2="898.13"
					y2="552.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="898.13"
					y1="552.16"
					x2="898.13"
					y2="557.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="872.45"
					y1="334.73"
					x2="872.45"
					y2="350.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="519.72"
					y1="314.3"
					x2="519.72"
					y2="317.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="535.5"
					y1="314.3"
					x2="535.5"
					y2="317.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="535.5"
					y1="314.3"
					x2="519.72"
					y2="314.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="519.72"
					y1="239.38"
					x2="519.72"
					y2="236.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="535.5"
					y1="239.38"
					x2="535.5"
					y2="236.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="535.5"
					y1="239.38"
					x2="519.72"
					y2="239.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="519.72"
					y1="234.28"
					x2="519.72"
					y2="239.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="518.74 240.37 519.72 240.37 519.72 236.43 518.74 236.43 518.74 240.37"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="519.72 313.32 518.74 313.32 518.74 317.26 519.72 317.26 519.72 313.32"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="535.5 240.37 536.48 240.37 536.48 236.43 535.5 236.43 535.5 240.37"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="536.48 313.32 535.5 313.32 535.5 317.26 536.48 317.26 536.48 313.32"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="518.74"
					y1="240.37"
					x2="518.74"
					y2="236.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="518.74"
					y1="236.43"
					x2="519.72"
					y2="236.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.72"
					y1="236.43"
					x2="519.72"
					y2="240.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.72"
					y1="240.37"
					x2="518.74"
					y2="240.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.72"
					y1="313.32"
					x2="519.72"
					y2="317.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.72"
					y1="317.26"
					x2="518.74"
					y2="317.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="518.74"
					y1="317.26"
					x2="518.74"
					y2="313.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="518.74"
					y1="313.32"
					x2="519.72"
					y2="313.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.5"
					y1="240.37"
					x2="535.5"
					y2="236.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.5"
					y1="236.43"
					x2="536.48"
					y2="236.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="536.48"
					y1="236.43"
					x2="536.48"
					y2="240.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="536.48"
					y1="240.37"
					x2="535.5"
					y2="240.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="536.48"
					y1="313.32"
					x2="536.48"
					y2="317.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="536.48"
					y1="317.26"
					x2="535.5"
					y2="317.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.5"
					y1="317.26"
					x2="535.5"
					y2="313.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.5"
					y1="313.32"
					x2="536.48"
					y2="313.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="519.72 241.35 535.5 241.35 535.5 239.88 519.72 239.88 519.72 241.35"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="519.72 313.81 535.5 313.81 535.5 312.33 519.72 312.33 519.72 313.81"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="585.68 262.14 583.24 259.7 533.06 309.89 535.5 312.33 585.68 262.14"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="535.5"
					y1="239.88"
					x2="535.5"
					y2="239.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.72"
					y1="239.88"
					x2="519.72"
					y2="239.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.5"
					y1="239.38"
					x2="519.72"
					y2="239.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.5"
					y1="313.81"
					x2="535.5"
					y2="314.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.72"
					y1="313.81"
					x2="519.72"
					y2="314.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.5"
					y1="314.3"
					x2="519.72"
					y2="314.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.72"
					y1="241.35"
					x2="535.5"
					y2="241.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.5"
					y1="241.35"
					x2="535.5"
					y2="239.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.5"
					y1="239.88"
					x2="519.72"
					y2="239.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.72"
					y1="239.88"
					x2="519.72"
					y2="241.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.72"
					y1="313.81"
					x2="535.5"
					y2="313.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.5"
					y1="313.81"
					x2="535.5"
					y2="312.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.5"
					y1="312.33"
					x2="519.72"
					y2="312.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.72"
					y1="312.33"
					x2="519.72"
					y2="313.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="585.68"
					y1="262.14"
					x2="583.24"
					y2="259.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.24"
					y1="259.7"
					x2="533.06"
					y2="309.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="533.06"
					y1="309.89"
					x2="535.5"
					y2="312.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.5"
					y1="312.33"
					x2="585.68"
					y2="262.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.5"
					y1="239.38"
					x2="519.72"
					y2="239.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="535.5"
					y1="239.38"
					x2="519.72"
					y2="239.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="535.5"
					y1="239.38"
					x2="535.5"
					y2="236.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="535.5"
					y1="239.38"
					x2="535.5"
					y2="236.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="519.72"
					y1="239.38"
					x2="519.72"
					y2="236.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="519.72"
					y1="239.38"
					x2="519.72"
					y2="236.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="535.5"
					y1="314.3"
					x2="519.72"
					y2="314.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="535.5"
					y1="314.3"
					x2="519.72"
					y2="314.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="535.5"
					y1="314.3"
					x2="535.5"
					y2="317.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="535.5"
					y1="314.3"
					x2="535.5"
					y2="317.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="519.72"
					y1="314.3"
					x2="519.72"
					y2="317.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="519.72"
					y1="314.3"
					x2="519.72"
					y2="317.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="474.49"
					y1="169.02"
					x2="474.49"
					y2="184.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="231.56"
					y1="949.01"
					x2="234.52"
					y2="949.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="231.56"
					y1="933.24"
					x2="234.52"
					y2="933.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="231.56"
					y1="933.24"
					x2="231.56"
					y2="949.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="160.59"
					y1="949.01"
					x2="157.63"
					y2="949.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="160.59"
					y1="933.24"
					x2="157.63"
					y2="933.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="160.59"
					y1="933.24"
					x2="160.59"
					y2="949.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="236.61"
					y1="933.24"
					x2="231.56"
					y2="933.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="161.57 950 161.57 949.01 157.63 949.01 157.63 950 161.57 950"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="230.58 949.01 230.58 950 234.52 950 234.52 949.01 230.58 949.01"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="161.57 933.24 161.57 932.25 157.63 932.25 157.63 933.24 161.57 933.24"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="230.58 932.25 230.58 933.24 234.52 933.24 234.52 932.25 230.58 932.25"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="161.57"
					y1="950"
					x2="157.63"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="157.63"
					y1="950"
					x2="157.63"
					y2="949.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="157.63"
					y1="949.01"
					x2="161.57"
					y2="949.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="161.57"
					y1="949.01"
					x2="161.57"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="230.58"
					y1="949.01"
					x2="234.52"
					y2="949.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.52"
					y1="949.01"
					x2="234.52"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.52"
					y1="950"
					x2="230.58"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="230.58"
					y1="950"
					x2="230.58"
					y2="949.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="161.57"
					y1="933.24"
					x2="157.63"
					y2="933.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="157.63"
					y1="933.24"
					x2="157.63"
					y2="932.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="157.63"
					y1="932.25"
					x2="161.57"
					y2="932.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="161.57"
					y1="932.25"
					x2="161.57"
					y2="933.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="230.58"
					y1="932.25"
					x2="234.52"
					y2="932.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.52"
					y1="932.25"
					x2="234.52"
					y2="933.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.52"
					y1="933.24"
					x2="230.58"
					y2="933.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="230.58"
					y1="933.24"
					x2="230.58"
					y2="932.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="162.56 949.01 162.56 933.24 161.08 933.24 161.08 949.01 162.56 949.01"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="231.07 949.01 231.07 933.24 229.59 933.24 229.59 949.01 231.07 949.01"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="182.19 885.84 179.75 888.28 227.15 935.68 229.59 933.24 182.19 885.84"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="161.08"
					y1="933.24"
					x2="160.59"
					y2="933.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="161.08"
					y1="949.01"
					x2="160.59"
					y2="949.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="160.59"
					y1="933.24"
					x2="160.59"
					y2="949.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.07"
					y1="933.24"
					x2="231.56"
					y2="933.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.07"
					y1="949.01"
					x2="231.56"
					y2="949.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.56"
					y1="933.24"
					x2="231.56"
					y2="949.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="162.56"
					y1="949.01"
					x2="162.56"
					y2="933.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="162.56"
					y1="933.24"
					x2="161.08"
					y2="933.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="161.08"
					y1="933.24"
					x2="161.08"
					y2="949.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="161.08"
					y1="949.01"
					x2="162.56"
					y2="949.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.07"
					y1="949.01"
					x2="231.07"
					y2="933.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.07"
					y1="933.24"
					x2="229.59"
					y2="933.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="229.59"
					y1="933.24"
					x2="229.59"
					y2="949.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="229.59"
					y1="949.01"
					x2="231.07"
					y2="949.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="182.19"
					y1="885.84"
					x2="179.75"
					y2="888.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="179.75"
					y1="888.28"
					x2="227.15"
					y2="935.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.15"
					y1="935.68"
					x2="229.59"
					y2="933.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="229.59"
					y1="933.24"
					x2="182.19"
					y2="885.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="160.59"
					y1="933.24"
					x2="160.59"
					y2="949.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="160.59"
					y1="933.24"
					x2="160.59"
					y2="949.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="160.59"
					y1="933.24"
					x2="157.63"
					y2="933.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="160.59"
					y1="933.24"
					x2="157.63"
					y2="933.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="160.59"
					y1="949.01"
					x2="157.63"
					y2="949.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="160.59"
					y1="949.01"
					x2="157.63"
					y2="949.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="231.56"
					y1="933.24"
					x2="231.56"
					y2="949.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="231.56"
					y1="933.24"
					x2="231.56"
					y2="949.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="231.56"
					y1="933.24"
					x2="234.52"
					y2="933.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="231.56"
					y1="933.24"
					x2="234.52"
					y2="933.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="231.56"
					y1="949.01"
					x2="234.52"
					y2="949.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="231.56"
					y1="949.01"
					x2="234.52"
					y2="949.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="246.47"
					y1="760.08"
					x2="246.47"
					y2="757.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="236.61"
					y1="760.08"
					x2="236.61"
					y2="757.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="236.61"
					y1="760.08"
					x2="246.47"
					y2="760.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="246.47"
					y1="815.28"
					x2="246.47"
					y2="818.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="236.61"
					y1="815.28"
					x2="236.61"
					y2="818.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="236.61"
					y1="815.28"
					x2="246.47"
					y2="815.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="246.47"
					y1="760.08"
					x2="246.47"
					y2="755.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="247.46 814.3 246.47 814.3 246.47 818.24 247.46 818.24 247.46 814.3"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="246.47 761.06 247.46 761.06 247.46 757.12 246.47 757.12 246.47 761.06"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="236.61 814.3 235.63 814.3 235.63 818.24 236.61 818.24 236.61 814.3"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="235.63 761.06 236.61 761.06 236.61 757.12 235.63 757.12 235.63 761.06"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="247.46"
					y1="814.3"
					x2="247.46"
					y2="818.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.46"
					y1="818.24"
					x2="246.47"
					y2="818.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.47"
					y1="818.24"
					x2="246.47"
					y2="814.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.47"
					y1="814.3"
					x2="247.46"
					y2="814.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.47"
					y1="761.06"
					x2="246.47"
					y2="757.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.47"
					y1="757.12"
					x2="247.46"
					y2="757.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.46"
					y1="757.12"
					x2="247.46"
					y2="761.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.46"
					y1="761.06"
					x2="246.47"
					y2="761.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.61"
					y1="814.3"
					x2="236.61"
					y2="818.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.61"
					y1="818.24"
					x2="235.63"
					y2="818.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.63"
					y1="818.24"
					x2="235.63"
					y2="814.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.63"
					y1="814.3"
					x2="236.61"
					y2="814.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.63"
					y1="761.06"
					x2="235.63"
					y2="757.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.63"
					y1="757.12"
					x2="236.61"
					y2="757.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.61"
					y1="757.12"
					x2="236.61"
					y2="761.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.61"
					y1="761.06"
					x2="235.63"
					y2="761.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="246.47 813.31 236.61 813.31 236.61 814.79 246.47 814.79 246.47 813.31"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="246.47 760.57 236.61 760.57 236.61 762.05 246.47 762.05 246.47 760.57"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="200.36 798.3 202.8 800.74 239.05 764.49 236.61 762.05 200.36 798.3"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="236.61"
					y1="814.79"
					x2="236.61"
					y2="815.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.47"
					y1="814.79"
					x2="246.47"
					y2="815.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.61"
					y1="815.28"
					x2="246.47"
					y2="815.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.61"
					y1="760.57"
					x2="236.61"
					y2="760.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.47"
					y1="760.57"
					x2="246.47"
					y2="760.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.61"
					y1="760.08"
					x2="246.47"
					y2="760.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.47"
					y1="813.31"
					x2="236.61"
					y2="813.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.61"
					y1="813.31"
					x2="236.61"
					y2="814.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.61"
					y1="814.79"
					x2="246.47"
					y2="814.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.47"
					y1="814.79"
					x2="246.47"
					y2="813.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.47"
					y1="760.57"
					x2="236.61"
					y2="760.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.61"
					y1="760.57"
					x2="236.61"
					y2="762.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.61"
					y1="762.05"
					x2="246.47"
					y2="762.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.47"
					y1="762.05"
					x2="246.47"
					y2="760.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="200.36"
					y1="798.3"
					x2="202.8"
					y2="800.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="202.8"
					y1="800.74"
					x2="239.05"
					y2="764.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.05"
					y1="764.49"
					x2="236.61"
					y2="762.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.61"
					y1="762.05"
					x2="200.36"
					y2="798.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.61"
					y1="815.28"
					x2="246.47"
					y2="815.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="236.61"
					y1="815.28"
					x2="246.47"
					y2="815.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="236.61"
					y1="815.28"
					x2="236.61"
					y2="818.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="236.61"
					y1="815.28"
					x2="236.61"
					y2="818.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="246.47"
					y1="815.28"
					x2="246.47"
					y2="818.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="246.47"
					y1="815.28"
					x2="246.47"
					y2="818.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="236.61"
					y1="760.08"
					x2="246.47"
					y2="760.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="236.61"
					y1="760.08"
					x2="246.47"
					y2="760.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="236.61"
					y1="760.08"
					x2="236.61"
					y2="757.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="236.61"
					y1="760.08"
					x2="236.61"
					y2="757.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="246.47"
					y1="760.08"
					x2="246.47"
					y2="757.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="246.47"
					y1="760.08"
					x2="246.47"
					y2="757.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="574.5"
					y1="589.58"
					x2="574.5"
					y2="592.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="576.47"
					y1="589.58"
					x2="574.5"
					y2="589.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="584.36"
					y1="589.58"
					x2="584.36"
					y2="592.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="584.36"
					y1="589.58"
					x2="576.47"
					y2="589.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="574.5"
					y1="474.25"
					x2="574.5"
					y2="471.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="576.47"
					y1="474.25"
					x2="574.5"
					y2="474.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="584.36"
					y1="474.25"
					x2="584.36"
					y2="471.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="584.36"
					y1="474.25"
					x2="576.47"
					y2="474.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="574.5"
					y1="469"
					x2="574.5"
					y2="474.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="576.47 475.72 576.47 474.74 574.5 474.74 574.5 475.72 576.47 475.72"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="573.52 475.72 574.5 475.72 574.5 471.78 573.52 471.78 573.52 475.72"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="576.47 589.09 576.47 588.1 574.5 588.1 574.5 589.09 576.47 589.09"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="574.5 588.1 573.52 588.1 573.52 592.04 574.5 592.04 574.5 588.1"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="584.36 475.72 586.82 475.72 586.82 471.78 584.36 471.78 584.36 475.72"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="586.82 588.1 584.36 588.1 584.36 592.04 586.82 592.04 586.82 588.1"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="576.47"
					y1="475.72"
					x2="574.5"
					y2="475.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.5"
					y1="475.72"
					x2="574.5"
					y2="474.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.5"
					y1="474.74"
					x2="576.47"
					y2="474.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.47"
					y1="474.74"
					x2="576.47"
					y2="475.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="573.52"
					y1="475.72"
					x2="573.52"
					y2="471.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="573.52"
					y1="471.78"
					x2="574.5"
					y2="471.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.5"
					y1="471.78"
					x2="574.5"
					y2="475.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.5"
					y1="475.72"
					x2="573.52"
					y2="475.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.47"
					y1="589.09"
					x2="574.5"
					y2="589.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.5"
					y1="589.09"
					x2="574.5"
					y2="588.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.5"
					y1="588.1"
					x2="576.47"
					y2="588.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.47"
					y1="588.1"
					x2="576.47"
					y2="589.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.5"
					y1="588.1"
					x2="574.5"
					y2="592.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.5"
					y1="592.04"
					x2="573.52"
					y2="592.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="573.52"
					y1="592.04"
					x2="573.52"
					y2="588.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="573.52"
					y1="588.1"
					x2="574.5"
					y2="588.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.36"
					y1="475.72"
					x2="584.36"
					y2="471.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.36"
					y1="471.78"
					x2="586.82"
					y2="471.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.82"
					y1="471.78"
					x2="586.82"
					y2="475.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.82"
					y1="475.72"
					x2="584.36"
					y2="475.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.82"
					y1="588.1"
					x2="586.82"
					y2="592.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.82"
					y1="592.04"
					x2="584.36"
					y2="592.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.36"
					y1="592.04"
					x2="584.36"
					y2="588.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.36"
					y1="588.1"
					x2="586.82"
					y2="588.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="584.36 478.68 584.36 474.74 576.47 474.74 576.47 478.68 584.36 478.68"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="584.36 589.09 584.36 585.15 576.47 585.15 576.47 589.09 584.36 589.09"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="576.47 529.94 576.47 585.15 579.92 585.15 579.92 529.94 576.47 529.94"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="579.92 502.34 579.92 557.54 583.37 557.54 583.37 502.34 579.92 502.34"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="576.47"
					y1="474.74"
					x2="576.47"
					y2="474.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.36"
					y1="474.74"
					x2="584.36"
					y2="474.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.47"
					y1="474.25"
					x2="584.36"
					y2="474.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.47"
					y1="589.09"
					x2="576.47"
					y2="589.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.36"
					y1="589.09"
					x2="584.36"
					y2="589.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.47"
					y1="589.58"
					x2="584.36"
					y2="589.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.36"
					y1="478.68"
					x2="576.47"
					y2="478.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.47"
					y1="478.68"
					x2="576.47"
					y2="474.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.47"
					y1="474.74"
					x2="584.36"
					y2="474.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.36"
					y1="474.74"
					x2="584.36"
					y2="478.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.36"
					y1="589.09"
					x2="576.47"
					y2="589.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.47"
					y1="589.09"
					x2="576.47"
					y2="585.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.47"
					y1="585.15"
					x2="584.36"
					y2="585.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.36"
					y1="585.15"
					x2="584.36"
					y2="589.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.47"
					y1="529.94"
					x2="579.92"
					y2="529.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="579.92"
					y1="529.94"
					x2="579.92"
					y2="585.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="579.92"
					y1="585.15"
					x2="576.47"
					y2="585.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.47"
					y1="585.15"
					x2="576.47"
					y2="529.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="579.92"
					y1="502.34"
					x2="583.37"
					y2="502.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.37"
					y1="502.34"
					x2="583.37"
					y2="557.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.37"
					y1="557.54"
					x2="579.92"
					y2="557.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="579.92"
					y1="557.54"
					x2="579.92"
					y2="502.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.36"
					y1="474.25"
					x2="576.47"
					y2="474.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="584.36"
					y1="474.25"
					x2="576.47"
					y2="474.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="576.47"
					y1="474.25"
					x2="574.5"
					y2="474.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="584.36"
					y1="474.25"
					x2="584.36"
					y2="471.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="576.47"
					y1="474.25"
					x2="574.5"
					y2="474.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="574.5"
					y1="474.25"
					x2="574.5"
					y2="471.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="574.5"
					y1="474.25"
					x2="574.5"
					y2="471.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="584.36"
					y1="589.58"
					x2="576.47"
					y2="589.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="584.36"
					y1="589.58"
					x2="576.47"
					y2="589.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="576.47"
					y1="589.58"
					x2="574.5"
					y2="589.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="584.36"
					y1="589.58"
					x2="584.36"
					y2="592.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="576.47"
					y1="589.58"
					x2="574.5"
					y2="589.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="574.5"
					y1="589.58"
					x2="574.5"
					y2="592.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="574.5"
					y1="589.58"
					x2="574.5"
					y2="592.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="519.72"
					y1="354.3"
					x2="519.72"
					y2="351.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="529.58"
					y1="354.3"
					x2="529.58"
					y2="351.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="529.58"
					y1="354.3"
					x2="519.72"
					y2="354.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="519.72"
					y1="425.28"
					x2="519.72"
					y2="428.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="529.58"
					y1="425.28"
					x2="529.58"
					y2="428.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="529.58"
					y1="425.28"
					x2="519.72"
					y2="425.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="519.72"
					y1="350.5"
					x2="519.72"
					y2="354.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="529.58"
					y1="604.53"
					x2="529.58"
					y2="469"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="529.58"
					y1="354.3"
					x2="529.58"
					y2="350.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="518.74 424.29 518.74 428.23 519.72 428.23 519.72 424.29 518.74 424.29"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="519.72 355.29 519.72 351.34 518.74 351.34 518.74 355.29 519.72 355.29"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="529.58 424.29 529.58 428.23 530.57 428.23 530.57 424.29 529.58 424.29"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="530.57 355.29 530.57 351.34 529.58 351.34 529.58 355.29 530.57 355.29"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="518.74"
					y1="424.29"
					x2="518.74"
					y2="428.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="518.74"
					y1="428.23"
					x2="519.72"
					y2="428.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.72"
					y1="428.23"
					x2="519.72"
					y2="424.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.72"
					y1="424.29"
					x2="518.74"
					y2="424.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.72"
					y1="355.29"
					x2="519.72"
					y2="351.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.72"
					y1="351.34"
					x2="518.74"
					y2="351.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="518.74"
					y1="351.34"
					x2="518.74"
					y2="355.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="518.74"
					y1="355.29"
					x2="519.72"
					y2="355.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="424.29"
					x2="529.58"
					y2="428.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="428.23"
					x2="530.57"
					y2="428.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="530.57"
					y1="428.23"
					x2="530.57"
					y2="424.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="530.57"
					y1="424.29"
					x2="529.58"
					y2="424.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="530.57"
					y1="355.29"
					x2="530.57"
					y2="351.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="530.57"
					y1="351.34"
					x2="529.58"
					y2="351.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="351.34"
					x2="529.58"
					y2="355.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="355.29"
					x2="530.57"
					y2="355.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="519.72 423.31 519.72 424.79 529.58 424.79 529.58 423.31 519.72 423.31"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="519.72 354.79 519.72 356.27 529.58 356.27 529.58 354.79 519.72 354.79"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="576.98 403.67 529.58 356.27 527.14 358.71 574.54 406.11 576.98 403.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="529.58"
					y1="424.79"
					x2="529.58"
					y2="425.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.72"
					y1="424.79"
					x2="519.72"
					y2="425.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="425.28"
					x2="519.72"
					y2="425.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="354.79"
					x2="529.58"
					y2="354.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.72"
					y1="354.79"
					x2="519.72"
					y2="354.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="354.3"
					x2="519.72"
					y2="354.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.72"
					y1="423.31"
					x2="529.58"
					y2="423.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="423.31"
					x2="529.58"
					y2="424.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="424.79"
					x2="519.72"
					y2="424.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.72"
					y1="424.79"
					x2="519.72"
					y2="423.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.72"
					y1="354.79"
					x2="529.58"
					y2="354.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="354.79"
					x2="529.58"
					y2="356.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="356.27"
					x2="519.72"
					y2="356.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.72"
					y1="356.27"
					x2="519.72"
					y2="354.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.98"
					y1="403.67"
					x2="574.54"
					y2="406.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.54"
					y1="406.11"
					x2="527.14"
					y2="358.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="527.14"
					y1="358.71"
					x2="529.58"
					y2="356.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="356.27"
					x2="576.98"
					y2="403.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="425.28"
					x2="519.72"
					y2="425.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="529.58"
					y1="425.28"
					x2="519.72"
					y2="425.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="529.58"
					y1="425.28"
					x2="529.58"
					y2="428.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="529.58"
					y1="425.28"
					x2="529.58"
					y2="428.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="519.72"
					y1="425.28"
					x2="519.72"
					y2="428.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="519.72"
					y1="425.28"
					x2="519.72"
					y2="428.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="529.58"
					y1="354.3"
					x2="519.72"
					y2="354.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="529.58"
					y1="354.3"
					x2="519.72"
					y2="354.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="529.58"
					y1="354.3"
					x2="529.58"
					y2="351.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="529.58"
					y1="354.3"
					x2="529.58"
					y2="351.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="519.72"
					y1="354.3"
					x2="519.72"
					y2="351.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="519.72"
					y1="354.3"
					x2="519.72"
					y2="351.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="395.5"
					y1="571.51"
					x2="385.64"
					y2="571.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="385.64"
					y1="571.51"
					x2="335.94"
					y2="571.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="335.94"
					y1="571.51"
					x2="335.94"
					y2="451.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="507.13"
					y1="441.69"
					x2="510.09"
					y2="441.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="507.13"
					y1="451.55"
					x2="510.09"
					y2="451.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="507.13"
					y1="451.55"
					x2="507.13"
					y2="441.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="436.15"
					y1="441.69"
					x2="433.19"
					y2="441.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="436.15"
					y1="451.55"
					x2="433.19"
					y2="451.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="436.15"
					y1="451.55"
					x2="436.15"
					y2="441.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="437.14 440.71 433.19 440.71 433.19 441.69 437.14 441.69 437.14 440.71"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="506.14 441.69 510.09 441.69 510.09 440.71 506.14 440.71 506.14 441.69"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="437.14 451.55 433.19 451.55 433.19 452.54 437.14 452.54 437.14 451.55"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="506.14 452.54 510.09 452.54 510.09 451.55 506.14 451.55 506.14 452.54"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="437.14"
					y1="440.71"
					x2="433.19"
					y2="440.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.19"
					y1="440.71"
					x2="433.19"
					y2="441.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.19"
					y1="441.69"
					x2="437.14"
					y2="441.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.14"
					y1="441.69"
					x2="437.14"
					y2="440.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.14"
					y1="441.69"
					x2="510.09"
					y2="441.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.09"
					y1="441.69"
					x2="510.09"
					y2="440.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.09"
					y1="440.71"
					x2="506.14"
					y2="440.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.14"
					y1="440.71"
					x2="506.14"
					y2="441.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.14"
					y1="451.55"
					x2="433.19"
					y2="451.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.19"
					y1="451.55"
					x2="433.19"
					y2="452.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.19"
					y1="452.54"
					x2="437.14"
					y2="452.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.14"
					y1="452.54"
					x2="437.14"
					y2="451.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.14"
					y1="452.54"
					x2="510.09"
					y2="452.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.09"
					y1="452.54"
					x2="510.09"
					y2="451.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.09"
					y1="451.55"
					x2="506.14"
					y2="451.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.14"
					y1="451.55"
					x2="506.14"
					y2="452.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="438.12 441.69 436.65 441.69 436.65 451.55 438.12 451.55 438.12 441.69"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="506.64 441.69 505.16 441.69 505.16 451.55 506.64 451.55 506.64 441.69"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="457.76 498.95 505.16 451.55 502.72 449.11 455.32 496.51 457.76 498.95"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="436.65"
					y1="451.55"
					x2="436.15"
					y2="451.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.65"
					y1="441.69"
					x2="436.15"
					y2="441.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.15"
					y1="451.55"
					x2="436.15"
					y2="441.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.64"
					y1="451.55"
					x2="507.13"
					y2="451.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.64"
					y1="441.69"
					x2="507.13"
					y2="441.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.13"
					y1="451.55"
					x2="507.13"
					y2="441.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="438.12"
					y1="441.69"
					x2="438.12"
					y2="451.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="438.12"
					y1="451.55"
					x2="436.65"
					y2="451.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.65"
					y1="451.55"
					x2="436.65"
					y2="441.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.65"
					y1="441.69"
					x2="438.12"
					y2="441.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.64"
					y1="441.69"
					x2="506.64"
					y2="451.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.64"
					y1="451.55"
					x2="505.16"
					y2="451.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.16"
					y1="451.55"
					x2="505.16"
					y2="441.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.16"
					y1="441.69"
					x2="506.64"
					y2="441.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.76"
					y1="498.95"
					x2="455.32"
					y2="496.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.32"
					y1="496.51"
					x2="502.72"
					y2="449.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.72"
					y1="449.11"
					x2="505.16"
					y2="451.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.16"
					y1="451.55"
					x2="457.76"
					y2="498.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.15"
					y1="451.55"
					x2="436.15"
					y2="441.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="436.15"
					y1="451.55"
					x2="436.15"
					y2="441.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="436.15"
					y1="451.55"
					x2="433.19"
					y2="451.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="436.15"
					y1="451.55"
					x2="433.19"
					y2="451.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="436.15"
					y1="441.69"
					x2="433.19"
					y2="441.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="436.15"
					y1="441.69"
					x2="433.19"
					y2="441.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="507.13"
					y1="451.55"
					x2="507.13"
					y2="441.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="507.13"
					y1="451.55"
					x2="507.13"
					y2="441.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="507.13"
					y1="451.55"
					x2="510.09"
					y2="451.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="507.13"
					y1="451.55"
					x2="510.09"
					y2="451.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="507.13"
					y1="441.69"
					x2="510.09"
					y2="441.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="507.13"
					y1="441.69"
					x2="510.09"
					y2="441.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="314.77"
					y1="680.94"
					x2="332.01"
					y2="680.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="314.77"
					y1="680.94"
					x2="314.77"
					y2="671.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="314.77"
					y1="433.53"
					x2="314.77"
					y2="671.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="731.78"
					y1="334.73"
					x2="731.78"
					y2="153.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<line
					x1="727.83"
					y1="153.66"
					x2="727.83"
					y2="334.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<line
					x1="727.83"
					y1="334.73"
					x2="731.78"
					y2="334.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<path
					d="m531.56,153.73c-.04-1.19-.06-2.37-.06-3.56,0-55.32,44.85-100.17,100.17-100.17s100.17,44.85,100.17,100.17c0,1.19-.02,2.37-.06,3.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<path
					d="m535.5,153.66c-.04-1.16-.06-2.32-.06-3.49,0-53.15,43.08-96.23,96.23-96.23s96.23,43.08,96.23,96.23c0,1.16-.02,2.32-.06,3.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<line
					x1="531.56"
					y1="153.73"
					x2="531.56"
					y2="169.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<line
					x1="531.56"
					y1="169.02"
					x2="535.5"
					y2="169.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<line
					x1="535.5"
					y1="169.02"
					x2="535.5"
					y2="153.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<line
					x1="119.15"
					y1="169.02"
					x2="119.15"
					y2="184.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="238.06"
					y1="169.02"
					x2="238.06"
					y2="184.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="342.92"
					y1="184.79"
					x2="342.92"
					y2="169.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="913.91"
					y1="420.59"
					x2="898.13"
					y2="420.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="529.58"
					y1="350.5"
					x2="535.5"
					y2="350.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="587.4"
					y1="334.73"
					x2="587.4"
					y2="350.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="491.6 534.6 488.08 533.04 484.27 532.49 480.45 533.04 476.93 534.6 474.61 536.6 472.85 539.1 470.62 544.96 469.84 552.31 471.49 559.51 470.95 565.98 468.26 571.88 467.19 573.55 465.94 576.97 466.13 580.62 466.7 582.05 466.7 585.88 468.3 585.88 468.3 584.14 470.97 585.75 474.02 586.38 494.51 586.38 498.46 585.32 501.44 582.5 502.71 578.6 502.71 578.13 502.31 575.67 500.23 571.79 497.55 565.95 497.02 559.56 498.68 552.34 497.91 544.96 495.67 539.1 493.91 536.6 491.6 534.6"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="476.97"
					y1="568.18"
					x2="491.56"
					y2="568.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="494.51"
					y1="586.38"
					x2="484.27"
					y2="586.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="494.51"
					y1="585.64"
					x2="484.27"
					y2="585.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.02"
					y1="586.38"
					x2="484.27"
					y2="586.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.02"
					y1="585.64"
					x2="484.27"
					y2="585.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.18"
					y1="568.18"
					x2="491.18"
					y2="570.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.18"
					y1="570.9"
					x2="488.93"
					y2="570.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.93"
					y1="570.9"
					x2="488.93"
					y2="568.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="477.35"
					y1="568.18"
					x2="477.35"
					y2="570.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="477.35"
					y1="570.9"
					x2="479.6"
					y2="570.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.6"
					y1="570.9"
					x2="479.6"
					y2="568.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.3"
					y1="579.11"
					x2="468.3"
					y2="585.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="466.7"
					y1="579.11"
					x2="466.7"
					y2="585.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="466.7"
					y1="585.88"
					x2="468.3"
					y2="585.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="466.7"
					y1="579.11"
					x2="468.3"
					y2="579.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.27"
					y1="532.49"
					x2="486.71"
					y2="532.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="486.71"
					y1="532.77"
					x2="489.08"
					y2="533.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="489.08"
					y1="533.4"
					x2="491.6"
					y2="534.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.6"
					y1="534.6"
					x2="493.92"
					y2="536.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.92"
					y1="536.6"
					x2="495.67"
					y2="539.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.67"
					y1="539.1"
					x2="496.97"
					y2="541.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="496.97"
					y1="541.94"
					x2="497.91"
					y2="544.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="497.91"
					y1="544.96"
					x2="498.76"
					y2="549.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.76"
					y1="549.85"
					x2="498.8"
					y2="552.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.8"
					y1="552.31"
					x2="498.53"
					y2="554.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.53"
					y1="554.76"
					x2="497.42"
					y2="558.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="497.42"
					y1="558.57"
					x2="495.69"
					y2="562.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.69"
					y1="562.25"
					x2="493.64"
					y2="565.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.64"
					y1="565.54"
					x2="491.56"
					y2="568.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="497.02"
					y1="559.56"
					x2="497.04"
					y2="562.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="497.04"
					y1="562.97"
					x2="497.6"
					y2="566.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="497.6"
					y1="566.3"
					x2="499.01"
					y2="569.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.01"
					y1="569.87"
					x2="502.11"
					y2="575.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.11"
					y1="575.12"
					x2="502.7"
					y2="577.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.7"
					y1="577.73"
					x2="502.47"
					y2="580.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.47"
					y1="580.33"
					x2="501.46"
					y2="582.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.46"
					y1="582.7"
					x2="499.67"
					y2="584.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.67"
					y1="584.6"
					x2="497.92"
					y2="585.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="497.92"
					y1="585.57"
					x2="496.25"
					y2="586.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="496.25"
					y1="586.1"
					x2="494.51"
					y2="586.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="494.51"
					y1="585.64"
					x2="496.9"
					y2="585.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="496.9"
					y1="585.07"
					x2="498.32"
					y2="583.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.32"
					y1="583.87"
					x2="499.21"
					y2="582.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.21"
					y1="582.2"
					x2="499.64"
					y2="580"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.64"
					y1="580"
					x2="499.73"
					y2="577.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.73"
					y1="577.74"
					x2="499.72"
					y2="576.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.72"
					y1="576.61"
					x2="499.24"
					y2="575.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.24"
					y1="575.72"
					x2="498.69"
					y2="575.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.69"
					y1="575.46"
					x2="492.49"
					y2="573.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.49"
					y1="573.7"
					x2="489.42"
					y2="573.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="489.42"
					y1="573.17"
					x2="486.3"
					y2="572.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="486.3"
					y1="572.95"
					x2="484.27"
					y2="572.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.49"
					y1="559.51"
					x2="471.47"
					y2="562.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.47"
					y1="562.94"
					x2="470.91"
					y2="566.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="470.91"
					y1="566.28"
					x2="469.52"
					y2="569.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.52"
					y1="569.87"
					x2="466.42"
					y2="575.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="466.42"
					y1="575.12"
					x2="465.94"
					y2="576.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="465.94"
					y1="576.86"
					x2="465.83"
					y2="578.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="465.83"
					y1="578.65"
					x2="466.08"
					y2="580.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="466.08"
					y1="580.41"
					x2="466.7"
					y2="582.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.02"
					y1="585.64"
					x2="471.63"
					y2="585.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.63"
					y1="585.07"
					x2="470.21"
					y2="583.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="470.21"
					y1="583.87"
					x2="469.32"
					y2="582.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.32"
					y1="582.2"
					x2="468.89"
					y2="580"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.89"
					y1="580"
					x2="468.8"
					y2="577.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.8"
					y1="577.74"
					x2="468.81"
					y2="576.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.81"
					y1="576.61"
					x2="469.29"
					y2="575.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.29"
					y1="575.72"
					x2="469.84"
					y2="575.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.84"
					y1="575.46"
					x2="476.04"
					y2="573.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="476.04"
					y1="573.7"
					x2="479.12"
					y2="573.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.12"
					y1="573.17"
					x2="482.23"
					y2="572.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.23"
					y1="572.95"
					x2="484.27"
					y2="572.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.27"
					y1="532.49"
					x2="481.82"
					y2="532.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.82"
					y1="532.77"
					x2="479.45"
					y2="533.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.45"
					y1="533.4"
					x2="476.93"
					y2="534.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="476.93"
					y1="534.6"
					x2="474.61"
					y2="536.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.61"
					y1="536.6"
					x2="472.85"
					y2="539.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.85"
					y1="539.1"
					x2="471.56"
					y2="541.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.56"
					y1="541.94"
					x2="470.62"
					y2="544.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="470.62"
					y1="544.96"
					x2="469.77"
					y2="549.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.77"
					y1="549.85"
					x2="469.73"
					y2="552.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.73"
					y1="552.31"
					x2="470"
					y2="554.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="470"
					y1="554.76"
					x2="471.11"
					y2="558.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.11"
					y1="558.57"
					x2="472.83"
					y2="562.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.83"
					y1="562.25"
					x2="474.89"
					y2="565.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.89"
					y1="565.54"
					x2="476.97"
					y2="568.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.43"
					y1="573.7"
					x2="501.03"
					y2="573.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.03"
					y1="573.15"
					x2="499.91"
					y2="572.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.91"
					y1="572.31"
					x2="498.93"
					y2="572.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.93"
					y1="572.12"
					x2="492.64"
					y2="571.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.64"
					y1="571.58"
					x2="486.33"
					y2="571.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="486.33"
					y1="571.33"
					x2="484.27"
					y2="571.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.1"
					y1="573.7"
					x2="467.49"
					y2="573.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.49"
					y1="573.15"
					x2="468.62"
					y2="572.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.62"
					y1="572.31"
					x2="469.6"
					y2="572.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.6"
					y1="572.12"
					x2="475.89"
					y2="571.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="475.89"
					y1="571.58"
					x2="482.2"
					y2="571.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.2"
					y1="571.33"
					x2="484.27"
					y2="571.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.3"
					y1="584.14"
					x2="468.86"
					y2="584.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.86"
					y1="584.6"
					x2="470.61"
					y2="585.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="470.61"
					y1="585.57"
					x2="472.28"
					y2="586.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.28"
					y1="586.1"
					x2="474.02"
					y2="586.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="507.92 586.38 507.92 585.59 503.98 585.59 503.98 586.38 507.92 586.38"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="503.98"
					y1="586.38"
					x2="507.92"
					y2="586.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.98"
					y1="585.59"
					x2="503.98"
					y2="586.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.92"
					y1="585.59"
					x2="503.98"
					y2="585.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.92"
					y1="586.38"
					x2="507.92"
					y2="585.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="460.61 586.38 464.55 586.38 464.55 585.59 460.61 585.59 460.61 586.38"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="460.61"
					y1="585.59"
					x2="460.61"
					y2="586.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.55"
					y1="585.59"
					x2="460.61"
					y2="585.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.55"
					y1="586.38"
					x2="464.55"
					y2="585.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.61"
					y1="586.38"
					x2="464.55"
					y2="586.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="506.35 585.59 506.35 579.18 505.56 579.18 505.56 585.59 506.35 585.59"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="505.56"
					y1="585.59"
					x2="506.35"
					y2="585.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.56"
					y1="579.18"
					x2="505.56"
					y2="585.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.35"
					y1="579.18"
					x2="505.56"
					y2="579.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.35"
					y1="585.59"
					x2="506.35"
					y2="579.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="462.18 585.59 462.97 585.59 462.97 579.18 462.18 579.18 462.18 585.59"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="462.18"
					y1="579.18"
					x2="462.18"
					y2="585.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="462.97"
					y1="579.18"
					x2="462.18"
					y2="579.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="462.97"
					y1="585.59"
					x2="462.97"
					y2="579.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="462.18"
					y1="585.59"
					x2="462.97"
					y2="585.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="505.56 581.15 505.56 579.57 462.97 579.57 462.97 581.15 505.56 581.15"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="462.97"
					y1="581.15"
					x2="505.56"
					y2="581.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="462.97"
					y1="579.57"
					x2="462.97"
					y2="581.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.56"
					y1="579.57"
					x2="462.97"
					y2="579.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.56"
					y1="581.15"
					x2="505.56"
					y2="579.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="395.5 451.55 335.94 451.55 335.94 571.51 395.5 571.51 395.5 451.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="395.5"
					y1="571.51"
					x2="395.5"
					y2="451.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.94"
					y1="571.51"
					x2="395.5"
					y2="571.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.94"
					y1="451.55"
					x2="335.94"
					y2="571.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.5"
					y1="451.55"
					x2="335.94"
					y2="451.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="391.62"
					y1="567.63"
					x2="391.62"
					y2="455.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="391.62"
					y1="455.43"
					x2="339.82"
					y2="455.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.82"
					y1="455.43"
					x2="339.82"
					y2="567.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.82"
					y1="567.63"
					x2="391.62"
					y2="567.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="391.62"
					y1="567.63"
					x2="368.13"
					y2="517.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.82"
					y1="567.63"
					x2="363.31"
					y2="517.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="391.62"
					y1="455.43"
					x2="368.13"
					y2="505.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.82"
					y1="455.43"
					x2="363.31"
					y2="505.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="369.6"
					y1="511.53"
					x2="361.84"
					y2="511.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.72"
					y1="507.65"
					x2="365.72"
					y2="515.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m371.93,511.53c0-3.43-2.78-6.21-6.21-6.21s-6.21,2.78-6.21,6.21,2.78,6.21,6.21,6.21,6.21-2.78,6.21-6.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m369.6,511.53c0-2.14-1.74-3.88-3.88-3.88s-3.88,1.74-3.88,3.88,1.74,3.88,3.88,3.88,3.88-1.74,3.88-3.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="365.72 571.51 371.78 563.28 359.66 563.28 365.72 571.51"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="359.66"
					y1="563.28"
					x2="365.72"
					y2="571.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.78"
					y1="563.28"
					x2="359.66"
					y2="563.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.72"
					y1="571.51"
					x2="371.78"
					y2="563.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.72"
					y1="561.4"
					x2="365.72"
					y2="556.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.72"
					y1="563.28"
					x2="359.66"
					y2="563.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.66"
					y1="563.28"
					x2="365.72"
					y2="571.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.72"
					y1="563.28"
					x2="371.78"
					y2="563.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.78"
					y1="563.28"
					x2="365.72"
					y2="571.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="363.93"
					y1="561.56"
					x2="361.42"
					y2="557.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.51"
					y1="561.56"
					x2="370.02"
					y2="557.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="269.78 539.58 314.77 539.58 314.77 495.37 269.78 495.37 269.78 539.58"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="269.78"
					y1="495.37"
					x2="269.78"
					y2="497.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.78"
					y1="499.97"
					x2="269.78"
					y2="504.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.78"
					y1="507.54"
					x2="269.78"
					y2="512.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.78"
					y1="515.11"
					x2="269.78"
					y2="519.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.78"
					y1="522.68"
					x2="269.78"
					y2="527.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.78"
					y1="530.25"
					x2="269.78"
					y2="534.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.78"
					y1="537.82"
					x2="269.78"
					y2="539.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="314.77"
					y1="495.37"
					x2="312.62"
					y2="495.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="309.78"
					y1="495.37"
					x2="305.05"
					y2="495.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="302.21"
					y1="495.37"
					x2="297.48"
					y2="495.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="294.64"
					y1="495.37"
					x2="289.91"
					y2="495.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="287.07"
					y1="495.37"
					x2="282.34"
					y2="495.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="279.5"
					y1="495.37"
					x2="274.77"
					y2="495.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.93"
					y1="495.37"
					x2="269.78"
					y2="495.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="314.77"
					y1="539.58"
					x2="314.77"
					y2="537.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="314.77"
					y1="534.98"
					x2="314.77"
					y2="530.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="314.77"
					y1="527.41"
					x2="314.77"
					y2="522.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="314.77"
					y1="519.84"
					x2="314.77"
					y2="515.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="314.77"
					y1="512.27"
					x2="314.77"
					y2="507.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="314.77"
					y1="504.7"
					x2="314.77"
					y2="499.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="314.77"
					y1="497.13"
					x2="314.77"
					y2="495.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.78"
					y1="539.58"
					x2="271.93"
					y2="539.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.77"
					y1="539.58"
					x2="279.5"
					y2="539.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="282.34"
					y1="539.58"
					x2="287.07"
					y2="539.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="289.91"
					y1="539.58"
					x2="294.64"
					y2="539.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="297.48"
					y1="539.58"
					x2="302.21"
					y2="539.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.05"
					y1="539.58"
					x2="309.78"
					y2="539.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.62"
					y1="539.58"
					x2="314.77"
					y2="539.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="267.45 495.54 266.09 495.54 266.09 539.41 267.45 539.41 267.45 532.53 266.34 532.53 266.34 502.42 267.45 502.42 267.45 495.54"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="267.45"
					y1="502.42"
					x2="267.45"
					y2="495.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="266.34"
					y1="502.42"
					x2="267.45"
					y2="502.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="266.34"
					y1="532.53"
					x2="266.34"
					y2="502.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="267.45"
					y1="532.53"
					x2="266.34"
					y2="532.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="267.45"
					y1="539.41"
					x2="267.45"
					y2="532.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="266.09"
					y1="539.41"
					x2="267.45"
					y2="539.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="266.09"
					y1="495.54"
					x2="266.09"
					y2="539.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="267.45"
					y1="495.54"
					x2="266.09"
					y2="495.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<polyline
					points="267.45 493.82 267.45 541.13 269.78 541.13 269.78 493.82 267.45 493.82"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="269.78"
					y1="493.82"
					x2="267.45"
					y2="493.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="269.78"
					y1="541.13"
					x2="269.78"
					y2="493.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="267.45"
					y1="541.13"
					x2="269.78"
					y2="541.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="267.45"
					y1="493.82"
					x2="267.45"
					y2="541.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="267.45"
					y1="539.41"
					x2="266.09"
					y2="539.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="266.09"
					y1="539.41"
					x2="266.09"
					y2="495.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="266.09"
					y1="495.54"
					x2="267.45"
					y2="495.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.45"
					y1="541.13"
					x2="267.45"
					y2="493.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.45"
					y1="502.42"
					x2="266.34"
					y2="502.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="266.34"
					y1="502.42"
					x2="266.34"
					y2="532.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="266.34"
					y1="532.53"
					x2="267.45"
					y2="532.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.78"
					y1="541.13"
					x2="267.45"
					y2="541.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.45"
					y1="493.82"
					x2="269.78"
					y2="493.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.78"
					y1="493.82"
					x2="269.78"
					y2="541.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="260.13 745.41 260.13 680.94 332.01 680.94 332.01 745.41 260.13 745.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="260.13"
					y1="745.41"
					x2="260.13"
					y2="680.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.13"
					y1="680.94"
					x2="332.01"
					y2="680.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.01"
					y1="680.94"
					x2="332.01"
					y2="745.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.01"
					y1="745.41"
					x2="260.13"
					y2="745.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="265.06"
					y1="745.41"
					x2="265.06"
					y2="680.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="273.12 545.89 273.12 595 273.57 596.1 274.67 596.55 307.55 596.55 308.65 596.1 309.1 595 309.1 545.89 308.65 544.79 307.55 544.33 274.67 544.33 273.57 544.79 273.12 545.89"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m273.12,545.89c0-.86.7-1.55,1.55-1.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="307.55"
					y1="544.33"
					x2="274.67"
					y2="544.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m307.55,544.33c.86,0,1.55.69,1.55,1.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="309.1"
					y1="595"
					x2="309.1"
					y2="545.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m309.1,595c0,.86-.69,1.55-1.55,1.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.67"
					y1="596.55"
					x2="307.55"
					y2="596.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m274.67,596.55c-.86,0-1.55-.69-1.55-1.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.12"
					y1="545.89"
					x2="273.12"
					y2="595"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277"
					y1="549.77"
					x2="277"
					y2="591.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="278.55"
					y1="592.67"
					x2="299.79"
					y2="592.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="301.34"
					y1="591.12"
					x2="301.34"
					y2="549.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="299.79"
					y1="548.22"
					x2="278.55"
					y2="548.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277"
					y1="549.77"
					x2="277"
					y2="549.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m278.55,592.67c-.86,0-1.55-.69-1.55-1.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m301.34,591.12c0,.86-.69,1.55-1.55,1.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m299.79,548.22c.86,0,1.55.69,1.55,1.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m277,549.77c0-.86.69-1.55,1.55-1.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m295.9,570.44c0-1.28-1.04-2.33-2.33-2.33s-2.33,1.04-2.33,2.33,1.04,2.33,2.33,2.33,2.33-1.04,2.33-2.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="291.41 569.74 290.92 569.95 290.71 570.44 290.92 570.94 291.42 571.14 306.77 571.14 307.27 570.93 307.47 570.44 307.27 569.95 306.77 569.74 291.41 569.74"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="306.77"
					y1="569.74"
					x2="291.41"
					y2="569.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m306.77,569.74c.39,0,.7.31.7.7s-.31.7-.7.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.42"
					y1="571.14"
					x2="306.77"
					y2="571.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m291.42,571.14h0c-.38,0-.7-.31-.7-.7s.31-.7.7-.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="302.81 568.89 302.81 569.74 306.77 569.74 307.27 569.95 307.47 570.44 307.27 570.93 306.77 571.14 302.81 571.14 302.81 571.99 307.86 571.99 307.86 568.89 302.81 568.89"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="307.86"
					y1="568.89"
					x2="302.81"
					y2="568.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="307.86"
					y1="571.99"
					x2="307.86"
					y2="568.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="302.81"
					y1="571.99"
					x2="307.86"
					y2="571.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="302.81"
					y1="571.14"
					x2="302.81"
					y2="571.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="306.77"
					y1="571.14"
					x2="302.81"
					y2="571.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m306.77,569.74c.39,0,.7.31.7.7s-.31.7-.7.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="302.81"
					y1="569.74"
					x2="306.77"
					y2="569.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="302.81"
					y1="568.89"
					x2="302.81"
					y2="569.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="300.02 568.91 300.02 569.74 302.74 569.74 302.74 568.91 300.02 568.91"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="302.74"
					y1="568.91"
					x2="300.02"
					y2="568.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="302.74"
					y1="569.74"
					x2="302.74"
					y2="568.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="300.02"
					y1="569.74"
					x2="302.74"
					y2="569.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="300.02"
					y1="568.91"
					x2="300.02"
					y2="569.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="300.02 571.97 302.74 571.97 302.74 571.14 300.02 571.14 300.02 571.97"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="300.02"
					y1="571.14"
					x2="300.02"
					y2="571.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="302.74"
					y1="571.14"
					x2="300.02"
					y2="571.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="302.74"
					y1="571.97"
					x2="302.74"
					y2="571.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="300.02"
					y1="571.97"
					x2="302.74"
					y2="571.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="450.38 546.97 399.12 546.97 399.12 586.38 450.38 586.38 450.38 546.97"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="450.38"
					y1="546.97"
					x2="399.12"
					y2="546.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="450.38"
					y1="586.38"
					x2="399.12"
					y2="586.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.12"
					y1="546.97"
					x2="399.12"
					y2="586.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="450.38"
					y1="546.97"
					x2="450.38"
					y2="586.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="450.38"
					y1="584.83"
					x2="399.12"
					y2="584.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.47"
					y1="556.33"
					x2="405.03"
					y2="556.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="405.03"
					y1="556.33"
					x2="405.03"
					y2="579.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="405.03"
					y1="579.98"
					x2="444.47"
					y2="579.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.47"
					y1="579.98"
					x2="444.47"
					y2="556.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="446.02"
					y1="554.77"
					x2="403.48"
					y2="554.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.48"
					y1="554.77"
					x2="403.48"
					y2="581.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.48"
					y1="581.53"
					x2="446.02"
					y2="581.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="446.02"
					y1="581.53"
					x2="446.02"
					y2="554.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m427.08,574.64c0-1.29-1.04-2.33-2.33-2.33s-2.33,1.04-2.33,2.33,1.04,2.33,2.33,2.33,2.33-1.04,2.33-2.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="426.69 584.25 426.38 581 426.13 580.26 425.61 576.15 425.32 575.61 424.75 575.39 424.17 575.61 423.89 576.15 423.37 580.26 423.12 581 422.81 584.25 423.18 585.39 424.15 586.1 425.35 586.1 426.32 585.39 426.69 584.25"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m426.69,584.25c0,1.07-.87,1.94-1.94,1.94s-1.94-.87-1.94-1.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="423.12"
					y1="581"
					x2="422.81"
					y2="584.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m423.12,581c.02-.26.11-.52.25-.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="423.89"
					y1="576.15"
					x2="423.37"
					y2="580.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m423.89,576.15c.06-.43.42-.76.86-.76s.8.32.86.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="426.13"
					y1="580.26"
					x2="425.61"
					y2="576.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m426.13,580.26c.14.22.23.48.25.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="426.69"
					y1="584.25"
					x2="426.38"
					y2="581"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="423.69"
					y1="582.32"
					x2="423.69"
					y2="581.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="425.81"
					y1="581.16"
					x2="425.81"
					y2="582.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="425.81"
					y1="582.32"
					x2="423.69"
					y2="582.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m423.69,581.16c0-.58.47-1.05,1.06-1.05s1.05.47,1.05,1.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m423.37,580.26c.3-.47.82-.75,1.38-.75s1.07.28,1.38.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.81"
					y1="804.41"
					x2="252.18"
					y2="804.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="252.18"
					y1="804.41"
					x2="252.18"
					y2="770.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.81"
					y1="811.63"
					x2="264.81"
					y2="762.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="297.29"
					y1="762.91"
					x2="297.29"
					y2="811.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="297.29"
					y1="811.63"
					x2="248.57"
					y2="811.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="248.57"
					y1="762.91"
					x2="297.29"
					y2="762.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="249.48"
					y1="811.63"
					x2="249.48"
					y2="762.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.81"
					y1="770.13"
					x2="252.18"
					y2="770.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="248.57"
					y1="811.63"
					x2="248.57"
					y2="762.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.13"
					y1="683.09"
					x2="255.88"
					y2="683.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="255.88"
					y1="683.09"
					x2="255.88"
					y2="685.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="255.88"
					y1="685.24"
					x2="260.13"
					y2="685.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.45"
					y1="745.41"
					x2="267.45"
					y2="741.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.45"
					y1="738.26"
					x2="267.45"
					y2="733.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.45"
					y1="730.69"
					x2="267.45"
					y2="725.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.45"
					y1="723.11"
					x2="267.45"
					y2="718.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.45"
					y1="715.54"
					x2="267.45"
					y2="710.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.45"
					y1="707.97"
					x2="267.45"
					y2="703.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.45"
					y1="700.4"
					x2="267.45"
					y2="695.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.45"
					y1="692.83"
					x2="267.45"
					y2="688.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.45"
					y1="685.26"
					x2="267.45"
					y2="680.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.45"
					y1="433.53"
					x2="267.45"
					y2="680.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.45"
					y1="433.53"
					x2="314.77"
					y2="433.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="119.15"
					y1="169.02"
					x2="238.06"
					y2="169.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.06"
					y1="184.79"
					x2="119.15"
					y2="184.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.92"
					y1="169.02"
					x2="474.49"
					y2="169.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.49"
					y1="184.79"
					x2="342.92"
					y2="184.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="913.91"
					y1="420.59"
					x2="913.91"
					y2="552.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="898.13"
					y1="552.16"
					x2="898.13"
					y2="420.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.4"
					y1="350.5"
					x2="872.45"
					y2="350.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.45"
					y1="334.73"
					x2="587.4"
					y2="334.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.87"
					y1="804.41"
					x2="291.87"
					y2="770.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.87"
					y1="770.13"
					x2="268.42"
					y2="770.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.42"
					y1="770.13"
					x2="268.42"
					y2="804.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.42"
					y1="804.41"
					x2="291.87"
					y2="804.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="263.51 599.75 263.51 658.9 314.77 658.9 314.77 599.75 263.51 599.75"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="263.51"
					y1="599.75"
					x2="263.51"
					y2="658.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="314.77"
					y1="599.75"
					x2="314.77"
					y2="658.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.22"
					y1="599.75"
					x2="313.22"
					y2="658.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="263.51"
					y1="599.75"
					x2="314.77"
					y2="599.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="263.51"
					y1="658.9"
					x2="314.77"
					y2="658.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="265.84"
					y1="603.63"
					x2="265.84"
					y2="655.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="265.84"
					y1="655.02"
					x2="267.39"
					y2="656.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.39"
					y1="656.57"
					x2="310.89"
					y2="656.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="310.89"
					y1="656.57"
					x2="312.44"
					y2="655.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.44"
					y1="655.02"
					x2="312.44"
					y2="603.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.44"
					y1="603.63"
					x2="310.89"
					y2="602.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="310.89"
					y1="602.08"
					x2="267.39"
					y2="602.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.39"
					y1="602.08"
					x2="265.84"
					y2="603.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m284.08,614.54c0-4.29-3.48-7.76-7.76-7.76s-7.76,3.47-7.76,7.76,3.48,7.76,7.76,7.76,7.76-3.47,7.76-7.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m307.78,614.54c0-3.21-2.61-5.82-5.82-5.82s-5.82,2.61-5.82,5.82,2.61,5.82,5.82,5.82,5.82-2.61,5.82-5.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m282.14,644.11c0-3.21-2.61-5.82-5.82-5.82s-5.82,2.61-5.82,5.82,2.61,5.82,5.82,5.82,5.82-2.61,5.82-5.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m309.72,644.11c0-4.29-3.47-7.76-7.76-7.76s-7.76,3.48-7.76,7.76,3.47,7.76,7.76,7.76,7.76-3.47,7.76-7.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="433.53"
					x2="291.11"
					y2="438.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="441.31"
					x2="291.11"
					y2="446.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="448.88"
					x2="291.11"
					y2="453.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="456.45"
					x2="291.11"
					y2="461.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="464.02"
					x2="291.11"
					y2="468.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="471.59"
					x2="291.11"
					y2="476.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="479.16"
					x2="291.11"
					y2="483.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="486.73"
					x2="291.11"
					y2="491.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="494.3"
					x2="291.11"
					y2="499.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="501.87"
					x2="291.11"
					y2="506.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="509.44"
					x2="291.11"
					y2="514.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="517.01"
					x2="291.11"
					y2="521.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="524.59"
					x2="291.11"
					y2="529.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="532.15"
					x2="291.11"
					y2="536.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="539.72"
					x2="291.11"
					y2="544.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="547.3"
					x2="291.11"
					y2="552.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="554.87"
					x2="291.11"
					y2="559.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="562.44"
					x2="291.11"
					y2="567.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="570.01"
					x2="291.11"
					y2="574.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="577.58"
					x2="291.11"
					y2="582.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="585.15"
					x2="291.11"
					y2="589.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="592.72"
					x2="291.11"
					y2="597.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="600.29"
					x2="291.11"
					y2="605.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="607.86"
					x2="291.11"
					y2="612.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="615.43"
					x2="291.11"
					y2="620.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="623"
					x2="291.11"
					y2="627.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="630.58"
					x2="291.11"
					y2="635.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="638.15"
					x2="291.11"
					y2="642.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="645.72"
					x2="291.11"
					y2="650.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="653.29"
					x2="291.11"
					y2="658.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="660.86"
					x2="291.11"
					y2="665.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="668.43"
					x2="291.11"
					y2="673.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.11"
					y1="676"
					x2="291.11"
					y2="680.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="914.14 334.54 914.14 420.4 898.37 420.4 898.37 415.42 856.63 415.42 856.63 362.47 898.37 362.47 898.37 350.31 872.69 350.31 872.69 334.54 914.14 334.54"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.14"
				/>
				<polygon
					points="535.74 168.82 535.74 239.19 519.96 239.19 519.96 234.09 484.26 234.09 484.26 184.6 474.73 184.6 474.73 168.82 535.74 168.82"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.14"
				/>
				<polygon
					points="166.48 433.33 166.48 814.29 126.4 814.29 126.4 933.04 160.83 933.04 160.83 948.82 110.63 948.82 110.63 798.51 150.71 798.51 150.71 491.56 85.86 491.56 85.86 168.82 119.39 168.82 119.39 184.6 101.63 184.6 101.63 433.33 166.48 433.33"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.14"
				/>
				<polygon
					points="914.14 551.96 914.14 620.11 348.03 620.11 348.03 948.82 231.8 948.82 231.8 933.04 236.85 933.04 236.85 815.09 246.71 815.09 246.71 837.75 303.12 837.75 303.12 755.08 246.71 755.08 246.71 759.88 236.85 759.88 236.85 745.22 332.25 745.22 332.25 680.75 315.01 680.75 315.01 433.33 324.87 433.33 324.87 441.5 436.39 441.5 436.39 451.35 336.18 451.35 336.18 571.32 395.73 571.32 395.73 586.19 519.96 586.19 519.96 451.35 507.37 451.35 507.37 441.5 519.96 441.5 519.96 425.08 529.82 425.08 529.82 458.95 584.6 458.95 584.6 474.05 574.74 474.05 574.74 468.8 529.82 468.8 529.82 604.33 574.74 604.33 574.74 589.39 584.6 589.39 584.6 604.33 834.77 604.33 834.77 557.46 898.37 557.46 898.37 551.96 914.14 551.96"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.14"
				/>
				<polygon
					points="343.16 168.82 343.16 184.6 238.3 184.6 238.3 168.82 343.16 168.82 343.16 168.82"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.14"
				/>
				<polygon
					points="587.64 334.54 587.64 350.31 529.82 350.31 529.82 354.11 519.96 354.11 519.96 314.11 535.74 314.11 535.74 334.54 587.64 334.54"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.14"
				/>
			</g>
			<g id="text">
				<path d="m293.18,521.41v-9.14h3.15c.71,0,1.25.04,1.63.13.52.12.97.34,1.34.65.48.41.84.93,1.08,1.57.24.63.36,1.36.36,2.17,0,.69-.08,1.31-.24,1.85-.16.54-.37.98-.62,1.33-.25.35-.53.63-.84.83-.3.2-.66.35-1.09.46-.42.1-.91.16-1.47.16h-3.3Zm1.21-1.08h1.95c.6,0,1.07-.06,1.42-.17.35-.11.62-.27.82-.47.29-.29.51-.67.67-1.15.16-.49.24-1.07.24-1.77,0-.96-.16-1.69-.47-2.2-.31-.52-.69-.86-1.14-1.04-.32-.12-.85-.19-1.57-.19h-1.92v6.99Zm9.61,1.08l-2.43-9.14h1.24l1.39,5.99c.15.63.28,1.25.39,1.87.23-.98.37-1.54.41-1.69l1.74-6.17h1.46l1.31,4.63c.33,1.15.57,2.23.71,3.24.12-.58.27-1.24.46-1.99l1.43-5.88h1.22l-2.51,9.14h-1.17l-1.93-6.97c-.16-.58-.26-.94-.29-1.07-.1.42-.19.78-.27,1.07l-1.94,6.97h-1.23Z" />
				<path d="m293.42,718.46h-1.28l-1.54-2.58c-.14-.24-.28-.44-.41-.61-.13-.17-.27-.31-.41-.42-.14-.11-.29-.18-.45-.23-.16-.05-.34-.08-.54-.08h-.89v3.92h-1.08v-9.21h2.75c.4,0,.77.05,1.11.15.34.1.64.25.89.46.25.21.45.46.59.77.14.3.21.66.21,1.07,0,.32-.05.62-.15.89-.09.27-.23.5-.41.71-.18.21-.39.39-.64.54-.25.15-.53.26-.84.34v.03c.15.07.29.15.4.24.12.09.22.19.33.31.1.12.2.26.3.41.1.15.22.33.34.53l1.73,2.77Zm-5.52-8.23v3.34h1.46c.27,0,.52-.04.74-.12.23-.08.43-.2.6-.35.17-.15.3-.34.39-.56.09-.22.14-.47.14-.74,0-.49-.16-.88-.48-1.15-.32-.28-.78-.42-1.38-.42h-1.48Zm11.81,5.21h-4.64c.02.73.21,1.3.59,1.7.38.4.89.6,1.55.6.74,0,1.42-.24,2.04-.73v.99c-.58.42-1.34.63-2.29.63s-1.66-.3-2.19-.89c-.53-.6-.8-1.44-.8-2.52,0-1.02.29-1.86.87-2.5.58-.65,1.3-.97,2.16-.97s1.53.28,2,.83c.47.56.71,1.33.71,2.32v.55Zm-1.08-.89c0-.61-.15-1.08-.44-1.42-.29-.34-.69-.51-1.2-.51s-.92.18-1.27.53c-.35.36-.56.82-.64,1.39h3.55Zm5.8-4.89c-.21-.12-.44-.17-.7-.17-.74,0-1.1.46-1.1,1.39v1.01h1.54v.9h-1.54v5.68h-1.05v-5.68h-1.12v-.9h1.12v-1.07c0-.69.2-1.23.6-1.63.4-.4.89-.6,1.49-.6.32,0,.58.04.76.12v.95Z" />
				<path d="m305.54,718.6c-.2,0-.37-.07-.51-.21-.14-.14-.21-.31-.21-.51s.07-.37.21-.51c.14-.15.31-.22.51-.22s.37.07.51.22c.14.14.21.31.21.51s-.07.37-.21.51-.31.21-.51.21Z" />
				<path d="m439.45,522.83v-14.29h4.07c1.24,0,2.22.3,2.94.91.72.6,1.09,1.39,1.09,2.36,0,.81-.22,1.51-.66,2.11-.44.6-1.04,1.02-1.81,1.28v.04c.96.11,1.73.48,2.31,1.1.58.61.87,1.41.87,2.39,0,1.22-.44,2.21-1.32,2.97-.88.76-1.98,1.14-3.32,1.14h-4.17Zm1.67-12.78v4.61h1.71c.92,0,1.64-.22,2.16-.66.52-.45.79-1.07.79-1.87,0-1.39-.91-2.08-2.74-2.08h-1.92Zm0,6.12v5.14h2.27c.98,0,1.74-.23,2.28-.7.54-.47.82-1.1.82-1.91,0-1.69-1.15-2.53-3.45-2.53h-1.92Zm17.11,6.66h-1.63v-1.59h-.04c-.71,1.22-1.76,1.83-3.14,1.83-1.02,0-1.81-.27-2.39-.81-.57-.54-.86-1.25-.86-2.14,0-1.91,1.12-3.02,3.37-3.33l3.06-.43c0-1.73-.7-2.6-2.1-2.6-1.23,0-2.34.42-3.33,1.26v-1.67c1-.64,2.16-.96,3.47-.96,2.4,0,3.6,1.27,3.6,3.81v6.64Zm-1.63-5.16l-2.46.34c-.76.11-1.33.3-1.71.57-.39.27-.58.74-.58,1.43,0,.5.18.91.53,1.23.36.31.83.47,1.43.47.81,0,1.48-.28,2-.85.53-.57.8-1.29.8-2.16v-1.02Zm9.45,5.06c-.39.21-.89.32-1.52.32-1.79,0-2.68-1-2.68-2.99v-6.04h-1.75v-1.4h1.75v-2.49l1.63-.53v3.02h2.57v1.4h-2.57v5.75c0,.68.12,1.17.35,1.46.23.29.62.44,1.16.44.41,0,.77-.11,1.07-.34v1.4Zm10.66.1h-1.63v-5.88c0-2.13-.79-3.19-2.37-3.19-.8,0-1.47.31-2.01.93-.54.61-.82,1.4-.82,2.36v5.78h-1.63v-15.11h1.63v6.6h.04c.78-1.29,1.9-1.93,3.35-1.93,2.3,0,3.45,1.39,3.45,4.16v6.29Z" />
				<path d="m574.15,192.45v5.4h-1.67v-14.29h3.93c1.53,0,2.71.37,3.55,1.12.84.74,1.27,1.79,1.27,3.15s-.47,2.46-1.41,3.33c-.93.86-2.19,1.3-3.78,1.3h-1.88Zm0-7.37v5.86h1.75c1.16,0,2.04-.26,2.64-.79.61-.53.92-1.28.92-2.24,0-1.89-1.12-2.83-3.35-2.83h-1.96Zm16.69,12.78h-1.63v-1.59h-.04c-.71,1.22-1.76,1.83-3.14,1.83-1.02,0-1.81-.27-2.39-.81-.57-.54-.86-1.25-.86-2.14,0-1.91,1.12-3.02,3.37-3.33l3.06-.43c0-1.73-.7-2.6-2.1-2.6-1.23,0-2.34.42-3.33,1.26v-1.67c1-.64,2.16-.96,3.47-.96,2.4,0,3.6,1.27,3.6,3.81v6.64Zm-1.63-5.16l-2.46.34c-.76.11-1.33.3-1.71.57-.39.27-.58.74-.58,1.43,0,.5.18.91.53,1.23.36.31.83.47,1.43.47.81,0,1.48-.28,2-.85.53-.57.8-1.29.8-2.16v-1.02Zm9.31,5.06c-.39.21-.89.32-1.52.32-1.79,0-2.68-1-2.68-2.99v-6.04h-1.75v-1.4h1.75v-2.49l1.63-.53v3.02h2.57v1.4h-2.57v5.75c0,.68.12,1.17.35,1.46s.62.44,1.16.44c.41,0,.77-.11,1.07-.34v1.4Zm2.88-12.7c-.29,0-.54-.1-.75-.3-.21-.2-.31-.45-.31-.76s.1-.56.31-.76c.21-.21.46-.31.75-.31s.55.1.76.31c.21.2.32.45.32.76s-.11.54-.32.75c-.21.21-.46.31-.76.31Zm.8,12.8h-1.63v-10.2h1.63v10.2Zm7.42.24c-1.51,0-2.71-.48-3.62-1.43-.9-.96-1.35-2.22-1.35-3.8,0-1.71.47-3.05,1.41-4.02.94-.96,2.2-1.44,3.8-1.44s2.71.47,3.56,1.41c.86.94,1.29,2.24,1.29,3.9s-.46,2.93-1.39,3.92c-.92.98-2.15,1.46-3.7,1.46Zm.12-9.31c-1.05,0-1.88.36-2.49,1.08-.61.71-.92,1.69-.92,2.95s.31,2.16.93,2.86c.62.7,1.44,1.05,2.48,1.05s1.87-.34,2.43-1.03c.57-.68.86-1.66.86-2.92s-.29-2.26-.86-2.95c-.56-.69-1.38-1.04-2.43-1.04Z" />
				<polygon points="623.61 183.56 616.75 200.22 615.23 200.22 622.07 183.56 623.61 183.56" />
				<path d="m625.27,197.85v-14.29h4.07c1.24,0,2.22.3,2.94.91s1.09,1.39,1.09,2.36c0,.81-.22,1.51-.66,2.11-.44.6-1.04,1.02-1.81,1.28v.04c.96.11,1.73.48,2.31,1.1.58.61.87,1.41.87,2.39,0,1.22-.44,2.21-1.32,2.97-.88.76-1.98,1.14-3.32,1.14h-4.17Zm1.67-12.78v4.61h1.71c.92,0,1.64-.22,2.16-.66.52-.45.79-1.07.79-1.87,0-1.39-.91-2.08-2.74-2.08h-1.92Zm0,6.12v5.14h2.27c.98,0,1.74-.23,2.28-.7.54-.47.82-1.1.82-1.91,0-1.69-1.15-2.53-3.45-2.53h-1.92Zm17.1,6.66h-1.63v-1.59h-.04c-.71,1.22-1.76,1.83-3.14,1.83-1.02,0-1.81-.27-2.39-.81-.57-.54-.86-1.25-.86-2.14,0-1.91,1.12-3.02,3.37-3.33l3.06-.43c0-1.73-.7-2.6-2.1-2.6-1.23,0-2.34.42-3.33,1.26v-1.67c1-.64,2.16-.96,3.47-.96,2.4,0,3.6,1.27,3.6,3.81v6.64Zm-1.63-5.16l-2.46.34c-.76.11-1.33.3-1.71.57-.39.27-.58.74-.58,1.43,0,.5.18.91.53,1.23.36.31.83.47,1.43.47.81,0,1.48-.28,2-.85.53-.57.8-1.29.8-2.16v-1.02Zm6.35,5.16h-1.63v-15.11h1.63v15.11Zm10.26-.47c-.78.47-1.71.71-2.79.71-1.45,0-2.63-.47-3.53-1.42-.89-.95-1.34-2.18-1.34-3.69,0-1.68.48-3.03,1.45-4.05.96-1.02,2.25-1.53,3.86-1.53.9,0,1.69.17,2.37.5v1.67c-.76-.53-1.57-.8-2.43-.8-1.04,0-1.9.38-2.57,1.13-.66.74-1,1.72-1,2.94s.31,2.14.94,2.83c.63.69,1.47,1.04,2.53,1.04.89,0,1.73-.3,2.51-.89v1.55Zm6.73.71c-1.51,0-2.71-.48-3.62-1.43-.9-.96-1.35-2.22-1.35-3.8,0-1.71.47-3.05,1.41-4.02.94-.96,2.2-1.44,3.8-1.44s2.71.47,3.56,1.41c.86.94,1.29,2.24,1.29,3.9s-.46,2.93-1.39,3.92c-.92.98-2.15,1.46-3.7,1.46Zm.12-9.31c-1.05,0-1.88.36-2.49,1.08-.61.71-.92,1.69-.92,2.95s.31,2.16.93,2.86c.62.7,1.44,1.05,2.48,1.05s1.87-.34,2.43-1.03c.57-.68.86-1.66.86-2.92s-.29-2.26-.86-2.95c-.56-.69-1.38-1.04-2.43-1.04Zm16.04,9.07h-1.63v-5.82c0-2.17-.79-3.25-2.37-3.25-.82,0-1.49.31-2.03.93-.53.61-.8,1.39-.8,2.32v5.82h-1.63v-10.2h1.63v1.69h.04c.77-1.29,1.89-1.93,3.35-1.93,1.12,0,1.97.36,2.56,1.09.59.72.89,1.76.89,3.12v6.24Zm11.2-10.2l-4.69,11.84c-.84,2.11-2.01,3.17-3.53,3.17-.43,0-.78-.04-1.07-.13v-1.46c.35.12.67.18.97.18.82,0,1.44-.49,1.85-1.47l.82-1.93-3.99-10.18h1.81l2.76,7.85c.03.1.1.36.21.78h.06c.03-.16.1-.41.2-.76l2.9-7.87h1.69Z" />
				<path d="m168.14,876.13h-7.57v-14.29h7.25v1.51h-5.58v4.75h5.16v1.5h-5.16v5h5.9v1.51Zm11.02,0h-1.63v-5.82c0-2.17-.79-3.25-2.37-3.25-.82,0-1.49.31-2.03.93-.53.61-.8,1.39-.8,2.32v5.82h-1.63v-10.2h1.63v1.69h.04c.77-1.29,1.89-1.93,3.35-1.93,1.12,0,1.97.36,2.56,1.09.59.72.89,1.76.89,3.12v6.24Zm7.83-.1c-.39.21-.89.32-1.52.32-1.79,0-2.68-1-2.68-2.99v-6.04h-1.75v-1.4h1.75v-2.49l1.63-.53v3.02h2.57v1.4h-2.57v5.75c0,.68.12,1.17.35,1.46.23.29.62.44,1.16.44.41,0,.77-.11,1.07-.34v1.4Zm7.52-8.45c-.29-.22-.7-.33-1.24-.33-.7,0-1.28.33-1.75.99-.47.66-.7,1.55-.7,2.69v5.2h-1.63v-10.2h1.63v2.1h.04c.23-.72.59-1.28,1.07-1.67.48-.41,1.01-.61,1.6-.61.43,0,.75.05.98.14v1.69Zm9.92-1.65l-4.69,11.84c-.84,2.11-2.01,3.17-3.53,3.17-.43,0-.78-.04-1.07-.13v-1.46c.35.12.67.18.97.18.82,0,1.44-.49,1.85-1.47l.82-1.93-3.99-10.18h1.81l2.76,7.85c.03.1.1.36.21.78h.06c.03-.16.1-.41.2-.76l2.9-7.87h1.69Z" />
				<path d="m681.05,475.93v-14.29h4.07c1.24,0,2.22.3,2.94.91.72.6,1.09,1.39,1.09,2.36,0,.81-.22,1.51-.66,2.11-.44.6-1.04,1.02-1.81,1.28v.04c.96.11,1.73.48,2.31,1.1.58.61.87,1.41.87,2.39,0,1.22-.44,2.21-1.32,2.97-.88.76-1.98,1.14-3.32,1.14h-4.17Zm1.67-12.78v4.61h1.71c.92,0,1.64-.22,2.16-.66.52-.45.79-1.07.79-1.87,0-1.39-.91-2.08-2.74-2.08h-1.92Zm0,6.12v5.14h2.27c.98,0,1.74-.23,2.28-.7.54-.47.82-1.1.82-1.91,0-1.69-1.15-2.53-3.45-2.53h-1.92Zm17.99,1.96h-7.2c.03,1.14.33,2.01.92,2.63.58.62,1.39.93,2.41.93,1.15,0,2.21-.38,3.17-1.14v1.53c-.9.65-2.08.98-3.56.98s-2.57-.46-3.4-1.39c-.82-.93-1.24-2.24-1.24-3.92,0-1.59.45-2.88,1.35-3.88.9-1,2.02-1.5,3.36-1.5s2.37.43,3.1,1.3c.73.86,1.1,2.06,1.1,3.6v.86Zm-1.67-1.39c0-.94-.24-1.68-.69-2.2-.45-.52-1.07-.79-1.86-.79s-1.43.28-1.96.83c-.54.55-.87,1.27-1,2.16h5.51Zm12.84,6.08h-1.63v-1.73h-.04c-.76,1.32-1.93,1.97-3.51,1.97-1.28,0-2.31-.46-3.08-1.37-.76-.92-1.15-2.16-1.15-3.74,0-1.69.43-3.04,1.28-4.06.85-1.02,1.98-1.52,3.4-1.52s2.42.55,3.06,1.65h.04v-6.32h1.63v15.11Zm-1.63-4.61v-1.5c0-.82-.27-1.52-.82-2.09-.54-.57-1.24-.86-2.07-.86-1,0-1.78.37-2.35,1.1-.57.73-.86,1.74-.86,3.03,0,1.18.27,2.11.82,2.79.55.68,1.29,1.02,2.21,1.02s1.65-.33,2.21-.99c.57-.66.86-1.49.86-2.49Zm10.25-3.94c-.29-.22-.7-.33-1.24-.33-.7,0-1.28.33-1.75.99-.47.66-.7,1.55-.7,2.69v5.2h-1.63v-10.2h1.63v2.1h.04c.23-.72.59-1.28,1.07-1.67.48-.41,1.01-.61,1.6-.61.43,0,.75.05.98.14v1.69Zm6.03,8.79c-1.51,0-2.71-.47-3.62-1.43-.9-.96-1.35-2.22-1.35-3.8,0-1.71.47-3.05,1.41-4.02.94-.96,2.2-1.44,3.8-1.44s2.71.47,3.56,1.41c.86.94,1.29,2.24,1.29,3.9s-.46,2.93-1.39,3.92c-.92.98-2.15,1.46-3.7,1.46Zm.12-9.31c-1.05,0-1.88.36-2.49,1.08-.61.71-.92,1.69-.92,2.95s.31,2.16.93,2.86c.62.7,1.44,1.05,2.48,1.05s1.87-.34,2.43-1.03c.57-.68.86-1.66.86-2.92s-.29-2.26-.86-2.95c-.56-.69-1.38-1.04-2.43-1.04Zm11.82,9.31c-1.51,0-2.71-.47-3.62-1.43-.9-.96-1.35-2.22-1.35-3.8,0-1.71.47-3.05,1.41-4.02.94-.96,2.2-1.44,3.8-1.44s2.71.47,3.56,1.41c.86.94,1.29,2.24,1.29,3.9s-.46,2.93-1.39,3.92c-.92.98-2.15,1.46-3.7,1.46Zm.12-9.31c-1.05,0-1.88.36-2.49,1.08-.61.71-.92,1.69-.92,2.95s.31,2.16.93,2.86c.62.7,1.44,1.05,2.48,1.05s1.87-.34,2.43-1.03c.57-.68.86-1.66.86-2.92s-.29-2.26-.86-2.95c-.56-.69-1.38-1.04-2.43-1.04Zm22.05,9.07h-1.63v-5.86c0-1.13-.18-1.95-.53-2.45-.35-.5-.93-.76-1.75-.76-.7,0-1.29.32-1.78.96-.48.64-.73,1.4-.73,2.29v5.82h-1.63v-6.06c0-2.01-.77-3.01-2.32-3.01-.72,0-1.31.3-1.77.91-.46.6-.7,1.38-.7,2.34v5.82h-1.63v-10.2h1.63v1.61h.04c.72-1.24,1.78-1.85,3.17-1.85.7,0,1.31.2,1.82.59.52.39.87.89,1.07,1.52.76-1.41,1.89-2.11,3.39-2.11,2.25,0,3.37,1.39,3.37,4.16v6.29Z" />
				<path d="m685.14,497.12h-1.19v-8.98c-.09.09-.23.2-.41.32-.17.12-.37.23-.59.35-.22.12-.45.22-.7.33-.24.1-.48.18-.71.24v-1.2c.26-.07.54-.17.83-.29.29-.13.58-.26.86-.41.29-.15.55-.31.8-.48.25-.17.47-.33.65-.49h.45v10.62Zm9.68-2.94c0,.47-.09.9-.27,1.28-.17.38-.42.71-.75.99-.32.27-.7.48-1.15.63-.45.15-.94.22-1.49.22-.99,0-1.78-.19-2.36-.57v-1.28c.7.55,1.5.83,2.41.83.36,0,.69-.05.98-.14.29-.09.55-.22.75-.4.21-.17.37-.38.49-.63.12-.25.17-.52.17-.83,0-1.36-.97-2.04-2.9-2.04h-.86v-1.01h.82c1.71,0,2.57-.64,2.57-1.91,0-1.18-.65-1.77-1.96-1.77-.73,0-1.42.25-2.07.74v-1.15c.66-.4,1.45-.59,2.36-.59.43,0,.83.06,1.18.18.35.12.65.29.91.51.25.22.44.48.58.78.14.3.21.64.21,1.01,0,1.37-.69,2.25-2.07,2.64v.03c.35.04.68.13.98.26.3.13.56.3.78.51s.39.46.51.75c.13.29.19.6.19.95Z" />
				<rect x="697.11" y="486.73" width="1.05" height="3.24" />
				<path d="m705.45,486.73v6.86h1.33v1.09h-1.33v2.44h-1.17v-2.44h-4.88v-1.03c.45-.51.91-1.06,1.38-1.64.46-.58.91-1.18,1.33-1.78.43-.6.82-1.2,1.17-1.79.36-.6.67-1.17.91-1.72h1.27Zm-4.72,6.86h3.54v-5.09c-.36.63-.71,1.2-1.03,1.7-.32.5-.63.95-.93,1.36-.29.41-.57.77-.83,1.1-.27.33-.52.64-.75.93Z" />
				<path d="m709.54,486.73v3.24h-1.05v-3.24h1.05Zm2.41,0v3.24h-1.05v-3.24h1.05Z" />
				<path d="m723.83,489.7l-2.49,3.75,2.45,3.67h-1.38l-1.46-2.41c-.09-.15-.2-.34-.33-.57h-.03s-.14.23-.34.57l-1.49,2.41h-1.37l2.53-3.64-2.42-3.78h1.38l1.43,2.54c.11.19.21.38.31.58h.03l1.85-3.12h1.31Z" />
				<path d="m733.33,497.12h-1.19v-8.98c-.09.09-.23.2-.41.32-.17.12-.37.23-.59.35-.22.12-.45.22-.7.33-.24.1-.48.18-.71.24v-1.2c.26-.07.54-.17.83-.29.29-.13.58-.26.86-.41.29-.15.55-.31.8-.48.25-.17.47-.33.65-.49h.45v10.62Zm10.16-5.24c0,.87-.08,1.64-.24,2.31-.15.67-.38,1.24-.68,1.7-.29.46-.66.81-1.09,1.05-.43.24-.92.36-1.47.36-.52,0-.99-.11-1.4-.34-.41-.23-.75-.57-1.03-1.01-.28-.44-.49-.98-.64-1.62-.14-.64-.22-1.38-.22-2.2,0-.91.07-1.71.22-2.41.15-.7.38-1.28.67-1.75.29-.47.66-.83,1.09-1.07.44-.24.94-.36,1.51-.36,2.18,0,3.27,1.78,3.27,5.33Zm-1.22.12c0-2.96-.7-4.43-2.11-4.43-1.48,0-2.22,1.5-2.22,4.51,0,2.81.73,4.21,2.18,4.21s2.15-1.43,2.15-4.29Z" />
				<rect x="745.3" y="486.73" width="1.05" height="3.24" />
				<path d="m748.14,494.22c0-.28.04-.55.13-.83.09-.28.21-.54.37-.78.16-.24.36-.46.6-.66.24-.2.51-.36.82-.47-.45-.25-.81-.57-1.07-.96-.27-.4-.4-.83-.4-1.31,0-.38.07-.73.22-1.06.15-.32.36-.6.62-.84.26-.24.57-.42.93-.55.36-.14.74-.2,1.16-.2s.81.07,1.17.2c.36.14.67.32.93.56.26.24.46.52.61.84.14.32.22.67.22,1.05,0,.48-.13.92-.4,1.31-.27.39-.62.71-1.06.96.3.12.57.27.8.47.24.2.43.42.59.66.16.24.29.5.38.78.09.28.13.55.13.83,0,.45-.08.87-.25,1.25-.16.38-.4.7-.7.97-.29.27-.65.47-1.07.62-.41.15-.86.22-1.36.22s-.94-.07-1.36-.22c-.41-.15-.77-.36-1.07-.62-.3-.27-.53-.59-.7-.97-.16-.38-.25-.79-.25-1.25Zm1.29-.1c0,.32.05.62.14.88.1.26.24.48.42.67.18.18.4.33.66.43.26.1.55.14.86.14s.58-.05.84-.15c.26-.1.48-.24.66-.43.19-.18.33-.41.43-.67.11-.26.16-.55.16-.87,0-.29-.05-.56-.15-.81-.1-.26-.24-.48-.42-.67-.18-.19-.4-.35-.66-.46-.26-.11-.54-.17-.86-.17-.3,0-.58.05-.83.16-.25.1-.47.25-.66.43-.18.18-.33.41-.43.67-.11.26-.16.54-.16.85Zm.37-4.82c0,.25.04.48.13.69.09.21.21.39.37.55.16.15.34.28.55.37.21.09.43.13.67.13s.46-.05.67-.14c.21-.09.4-.21.55-.37.15-.16.28-.34.37-.55.09-.21.14-.44.14-.68s-.05-.48-.14-.7c-.09-.21-.21-.4-.36-.55-.15-.15-.34-.28-.55-.36-.21-.09-.43-.14-.67-.14-.26,0-.49.05-.7.14-.21.09-.39.22-.54.38-.15.15-.27.34-.35.55-.08.21-.12.44-.12.68Z" />
				<path d="m757.73,486.73v3.24h-1.05v-3.24h1.05Zm2.41,0v3.24h-1.05v-3.24h1.05Z" />
				<path d="m195.5,597.78h-2.33l-5.52-6.54c-.21-.25-.33-.41-.38-.5h-.04v7.04h-1.67v-14.29h1.67v6.72h.04c.09-.15.22-.31.38-.49l5.34-6.23h2.08l-6.13,6.86,6.56,7.43Zm2.5-12.8c-.29,0-.54-.1-.75-.3-.21-.2-.31-.45-.31-.76s.1-.56.31-.76c.21-.21.46-.31.75-.31s.55.1.76.31c.21.2.32.45.32.76s-.11.54-.32.75c-.21.21-.46.31-.76.31Zm.8,12.8h-1.63v-10.2h1.63v10.2Zm8.03-.1c-.39.21-.89.32-1.52.32-1.79,0-2.68-1-2.68-2.99v-6.04h-1.75v-1.4h1.75v-2.49l1.63-.53v3.02h2.57v1.4h-2.57v5.75c0,.68.12,1.17.35,1.46.23.29.62.44,1.16.44.41,0,.77-.11,1.07-.34v1.4Zm9.13-.37c-.78.47-1.71.71-2.79.71-1.45,0-2.63-.47-3.53-1.42-.89-.95-1.34-2.18-1.34-3.69,0-1.68.48-3.03,1.45-4.05.96-1.02,2.25-1.53,3.86-1.53.9,0,1.69.17,2.37.5v1.67c-.76-.53-1.57-.8-2.43-.8-1.04,0-1.9.38-2.57,1.13-.66.74-1,1.72-1,2.94s.31,2.14.94,2.83c.63.69,1.47,1.04,2.53,1.04.89,0,1.73-.3,2.51-.89v1.55Zm10.93.47h-1.63v-5.88c0-2.13-.79-3.19-2.37-3.19-.8,0-1.47.31-2.01.93-.54.61-.82,1.4-.82,2.36v5.78h-1.63v-15.11h1.63v6.6h.04c.78-1.29,1.9-1.93,3.35-1.93,2.3,0,3.45,1.39,3.45,4.16v6.29Zm11.27-4.69h-7.21c.03,1.14.33,2.01.92,2.63s1.39.93,2.41.93c1.15,0,2.21-.38,3.17-1.14v1.53c-.9.65-2.08.98-3.56.98s-2.57-.46-3.4-1.39c-.82-.93-1.24-2.24-1.24-3.92,0-1.59.45-2.88,1.35-3.88.9-1,2.02-1.5,3.36-1.5s2.37.43,3.1,1.3c.73.86,1.1,2.06,1.1,3.6v.86Zm-1.67-1.39c0-.94-.24-1.68-.69-2.2-.45-.52-1.07-.79-1.86-.79s-1.43.28-1.96.83c-.54.55-.87,1.27-1,2.16h5.51Zm12.6,6.08h-1.63v-5.82c0-2.17-.79-3.25-2.37-3.25-.82,0-1.49.31-2.03.93-.53.61-.8,1.39-.8,2.32v5.82h-1.63v-10.2h1.63v1.69h.04c.77-1.29,1.89-1.93,3.35-1.93,1.12,0,1.97.36,2.56,1.09.59.72.89,1.76.89,3.12v6.24Z" />
				<path d="m212.9,307.57h-7.41v-14.29h1.67v12.78h5.74v1.51Zm2.81-12.8c-.29,0-.54-.1-.75-.3-.21-.2-.31-.45-.31-.76s.1-.56.31-.76c.21-.21.46-.31.75-.31s.55.1.76.31c.21.2.32.45.32.76s-.11.54-.32.75c-.21.21-.46.31-.76.31Zm.8,12.8h-1.63v-10.2h1.63v10.2Zm11.32-10.2l-4.07,10.2h-1.6l-3.87-10.2h1.79l2.59,7.41c.19.54.31,1.02.36,1.43h.04c.07-.51.17-.97.32-1.39l2.71-7.45h1.72Zm2.58-2.59c-.29,0-.54-.1-.75-.3-.21-.2-.31-.45-.31-.76s.1-.56.31-.76c.21-.21.46-.31.75-.31s.55.1.76.31c.21.2.32.45.32.76s-.11.54-.32.75c-.21.21-.46.31-.76.31Zm.8,12.8h-1.63v-10.2h1.63v10.2Zm11.77,0h-1.63v-5.82c0-2.17-.79-3.25-2.37-3.25-.82,0-1.49.31-2.03.93-.53.61-.8,1.39-.8,2.32v5.82h-1.63v-10.2h1.63v1.69h.04c.77-1.29,1.89-1.93,3.35-1.93,1.12,0,1.97.36,2.56,1.09.59.72.89,1.76.89,3.12v6.24Zm11.78-.82c0,3.75-1.79,5.62-5.38,5.62-1.26,0-2.37-.24-3.31-.72v-1.63c1.15.64,2.25.96,3.29.96,2.51,0,3.77-1.34,3.77-4.01v-1.12h-.04c-.78,1.3-1.95,1.95-3.51,1.95-1.27,0-2.29-.45-3.07-1.36-.77-.91-1.16-2.13-1.16-3.66,0-1.73.42-3.11,1.25-4.14.84-1.02,1.98-1.53,3.43-1.53s2.4.55,3.06,1.65h.04v-1.42h1.63v9.39Zm-1.63-3.8v-1.5c0-.81-.28-1.5-.83-2.08-.54-.58-1.23-.87-2.04-.87-1.01,0-1.8.37-2.37,1.11-.57.73-.86,1.76-.86,3.08,0,1.14.27,2.05.82,2.73.55.68,1.28,1.02,2.18,1.02s1.66-.33,2.23-.98c.58-.65.87-1.48.87-2.5Z" />
				<polygon points="264.51 293.28 257.65 309.94 256.13 309.94 262.97 293.28 264.51 293.28" />
				<path d="m266.17,307.57v-14.29h3.95c5.04,0,7.55,2.32,7.55,6.97,0,2.21-.7,3.98-2.1,5.32-1.4,1.34-3.27,2-5.61,2h-3.79Zm1.67-12.78v11.26h2.13c1.87,0,3.33-.5,4.37-1.5,1.04-1,1.56-2.42,1.56-4.27,0-3.66-1.95-5.49-5.84-5.49h-2.23Zm13.19-.02c-.29,0-.54-.1-.75-.3-.21-.2-.31-.45-.31-.76s.1-.56.31-.76c.21-.21.46-.31.75-.31s.55.1.76.31c.21.2.32.45.32.76s-.11.54-.32.75c-.21.21-.46.31-.76.31Zm.8,12.8h-1.63v-10.2h1.63v10.2Zm11.71,0h-1.63v-5.82c0-2.17-.79-3.25-2.37-3.25-.82,0-1.49.31-2.03.93-.53.61-.8,1.39-.8,2.32v5.82h-1.63v-10.2h1.63v1.69h.04c.77-1.29,1.89-1.93,3.35-1.93,1.12,0,1.97.36,2.56,1.09.59.72.89,1.76.89,3.12v6.24Zm3.86-12.8c-.29,0-.54-.1-.75-.3-.21-.2-.31-.45-.31-.76s.1-.56.31-.76c.21-.21.46-.31.75-.31s.55.1.76.31c.21.2.32.45.32.76s-.11.54-.32.75c-.21.21-.46.31-.76.31Zm.8,12.8h-1.63v-10.2h1.63v10.2Zm11.71,0h-1.63v-5.82c0-2.17-.79-3.25-2.37-3.25-.82,0-1.49.31-2.03.93-.53.61-.8,1.39-.8,2.32v5.82h-1.63v-10.2h1.63v1.69h.04c.77-1.29,1.89-1.93,3.35-1.93,1.12,0,1.97.36,2.56,1.09.59.72.89,1.76.89,3.12v6.24Zm11.73-.82c0,3.75-1.79,5.62-5.38,5.62-1.26,0-2.37-.24-3.31-.72v-1.63c1.15.64,2.25.96,3.29.96,2.51,0,3.77-1.34,3.77-4.01v-1.12h-.04c-.78,1.3-1.95,1.95-3.51,1.95-1.27,0-2.29-.45-3.07-1.36-.77-.91-1.16-2.13-1.16-3.66,0-1.73.42-3.11,1.25-4.14.84-1.02,1.98-1.53,3.43-1.53s2.4.55,3.06,1.65h.04v-1.42h1.63v9.39Zm-1.63-3.8v-1.5c0-.81-.28-1.5-.83-2.08-.54-.58-1.23-.87-2.04-.87-1.01,0-1.8.37-2.37,1.11-.57.73-.86,1.76-.86,3.08,0,1.14.27,2.05.82,2.73.55.68,1.28,1.02,2.18,1.02s1.66-.33,2.23-.98c.58-.65.87-1.48.87-2.5Z" />
				<path d="m341.19,307.57h-1.99l-2.39-4.01c-.22-.37-.43-.69-.64-.95-.21-.27-.42-.48-.64-.65-.21-.17-.45-.29-.7-.36-.25-.08-.52-.12-.84-.12h-1.38v6.08h-1.67v-14.29h4.27c.62,0,1.2.08,1.72.24.53.15.99.39,1.38.71.39.32.7.72.92,1.2.22.47.33,1.03.33,1.66,0,.5-.08.96-.23,1.38-.15.41-.36.78-.64,1.11-.27.33-.6.6-1,.84-.39.23-.82.4-1.31.53v.04c.24.11.45.23.62.37.18.13.35.29.51.48.16.19.32.4.47.64.16.23.34.5.53.82l2.68,4.3Zm-8.57-12.78v5.18h2.27c.42,0,.8-.06,1.16-.19.36-.13.67-.31.93-.54.26-.24.46-.53.61-.87.15-.35.22-.73.22-1.16,0-.76-.25-1.36-.75-1.78-.49-.43-1.21-.65-2.14-.65h-2.29Zm14.52,13.01c-1.51,0-2.71-.48-3.62-1.43-.9-.96-1.35-2.22-1.35-3.8,0-1.71.47-3.05,1.41-4.02.94-.96,2.2-1.44,3.8-1.44s2.71.47,3.56,1.41c.86.94,1.29,2.24,1.29,3.9s-.46,2.93-1.39,3.92c-.92.98-2.15,1.46-3.7,1.46Zm.12-9.31c-1.05,0-1.88.36-2.49,1.08-.61.71-.92,1.69-.92,2.95s.31,2.16.93,2.86,1.44,1.05,2.48,1.05,1.87-.34,2.43-1.03c.57-.68.86-1.66.86-2.92s-.29-2.26-.86-2.95c-.56-.69-1.38-1.04-2.43-1.04Zm11.78,9.31c-1.51,0-2.71-.48-3.62-1.43-.9-.96-1.35-2.22-1.35-3.8,0-1.71.47-3.05,1.41-4.02.94-.96,2.2-1.44,3.8-1.44s2.71.47,3.56,1.41c.86.94,1.29,2.24,1.29,3.9s-.46,2.93-1.39,3.92c-.92.98-2.15,1.46-3.7,1.46Zm.12-9.31c-1.05,0-1.88.36-2.49,1.08-.61.71-.92,1.69-.92,2.95s.31,2.16.93,2.86c.62.7,1.44,1.05,2.48,1.05s1.87-.34,2.43-1.03c.57-.68.86-1.66.86-2.92s-.29-2.26-.86-2.95c-.56-.69-1.38-1.04-2.43-1.04Zm22,9.07h-1.63v-5.86c0-1.13-.18-1.95-.53-2.45-.35-.5-.93-.76-1.75-.76-.7,0-1.29.32-1.78.96-.49.64-.73,1.4-.73,2.29v5.82h-1.63v-6.06c0-2.01-.77-3.01-2.32-3.01-.72,0-1.31.3-1.77.91-.46.6-.7,1.38-.7,2.34v5.82h-1.63v-10.2h1.63v1.61h.04c.72-1.24,1.78-1.85,3.17-1.85.7,0,1.31.2,1.82.59.52.39.87.89,1.07,1.52.76-1.41,1.89-2.11,3.39-2.11,2.25,0,3.37,1.39,3.37,4.16v6.29Z" />
				<path d="m257.47,328.76h-1.19v-8.98c-.09.09-.23.2-.41.32-.17.12-.37.23-.59.35-.22.12-.45.22-.7.33-.24.1-.48.18-.71.24v-1.2c.26-.07.54-.17.83-.29.29-.13.58-.26.86-.41.29-.15.55-.31.8-.48.25-.17.47-.33.65-.49h.45v10.62Zm10.09-9.7c-.16.28-.35.62-.58,1.03-.22.41-.46.87-.71,1.38-.25.51-.51,1.06-.77,1.65-.26.59-.5,1.2-.73,1.83-.23.63-.43,1.27-.6,1.91-.17.64-.29,1.28-.37,1.9h-1.28c.09-.62.22-1.25.4-1.89.18-.65.39-1.28.62-1.9.23-.62.48-1.22.73-1.8s.5-1.1.75-1.59.46-.91.66-1.28c.2-.37.36-.66.49-.87h-5.21v-1.07h6.61v.69Z" />
				<rect x="269.43" y="318.37" width="1.05" height="3.24" />
				<path d="m272.27,325.86c0-.28.04-.55.13-.83.09-.28.21-.54.37-.78.16-.24.36-.46.6-.66.24-.2.51-.36.82-.47-.45-.25-.81-.57-1.07-.96-.27-.4-.4-.83-.4-1.31,0-.38.07-.73.22-1.06.15-.32.36-.6.62-.84.26-.24.57-.42.93-.55.36-.14.74-.2,1.16-.2s.81.07,1.17.2c.36.14.67.32.93.56.26.24.46.52.61.84.14.32.22.67.22,1.05,0,.48-.13.92-.4,1.31-.27.39-.62.71-1.06.96.3.12.57.27.8.47s.43.42.59.66c.16.24.29.5.38.78.09.28.13.55.13.83,0,.45-.08.87-.25,1.25s-.4.7-.7.97c-.29.27-.65.47-1.07.62-.41.15-.86.22-1.36.22s-.94-.07-1.35-.22c-.41-.15-.77-.36-1.07-.62-.3-.27-.53-.59-.7-.97-.16-.38-.25-.79-.25-1.25Zm1.29-.1c0,.32.05.62.14.88.1.26.24.48.42.67.18.18.4.33.66.43.26.1.55.14.86.14s.58-.05.84-.15c.26-.1.48-.24.66-.43.19-.18.33-.41.43-.67.11-.26.16-.55.16-.87,0-.29-.05-.56-.15-.81-.1-.26-.24-.48-.42-.67-.18-.19-.4-.35-.66-.46-.26-.11-.54-.17-.86-.17-.3,0-.58.05-.83.16-.25.1-.47.25-.66.43s-.33.41-.43.67c-.11.26-.16.54-.16.85Zm.37-4.82c0,.25.04.48.13.69.09.21.21.39.37.55.16.15.34.28.55.37.21.09.43.13.67.13s.46-.05.67-.14c.21-.09.4-.21.55-.37.15-.16.28-.34.37-.55.09-.21.14-.44.14-.68s-.05-.48-.14-.7c-.09-.21-.21-.4-.36-.55s-.34-.28-.55-.36c-.21-.09-.43-.14-.67-.14-.26,0-.49.05-.7.14-.21.09-.39.22-.54.38-.15.15-.27.34-.35.55-.08.21-.12.44-.12.68Z" />
				<path d="m281.87,318.37v3.24h-1.05v-3.24h1.05Zm2.41,0v3.24h-1.05v-3.24h1.05Z" />
				<path d="m296.15,321.34l-2.49,3.75,2.45,3.67h-1.38l-1.46-2.41c-.09-.15-.2-.34-.33-.57h-.03s-.14.23-.34.57l-1.49,2.41h-1.37l2.53-3.64-2.42-3.78h1.38l1.43,2.54c.11.19.21.38.31.58h.03l1.85-3.12h1.31Z" />
				<path d="m305.66,328.76h-1.19v-8.98c-.09.09-.23.2-.41.32-.17.12-.37.23-.59.35-.22.12-.45.22-.7.33-.24.1-.48.18-.71.24v-1.2c.26-.07.54-.17.83-.29.29-.13.58-.26.86-.41.29-.15.55-.31.8-.48.25-.17.47-.33.65-.49h.45v10.62Zm10.16-5.24c0,.87-.08,1.64-.24,2.31-.15.67-.38,1.24-.68,1.7-.29.46-.66.81-1.09,1.05-.43.24-.92.36-1.47.36-.52,0-.99-.11-1.4-.34-.41-.23-.75-.57-1.03-1.01-.28-.44-.49-.98-.64-1.62-.14-.64-.22-1.38-.22-2.2,0-.91.07-1.71.22-2.41.15-.7.38-1.28.67-1.75.29-.47.66-.83,1.09-1.07.44-.24.94-.36,1.51-.36,2.18,0,3.27,1.78,3.27,5.33Zm-1.22.12c0-2.96-.7-4.43-2.11-4.43-1.48,0-2.22,1.5-2.22,4.51,0,2.81.73,4.21,2.18,4.21s2.15-1.43,2.15-4.29Z" />
				<rect x="317.63" y="318.37" width="1.05" height="3.24" />
				<path d="m326.84,325.58c0,.51-.09.97-.26,1.38-.17.41-.42.76-.75,1.06-.32.29-.71.52-1.16.68-.45.16-.96.24-1.51.24-.97,0-1.68-.14-2.15-.43v-1.26c.71.45,1.43.68,2.17.68.38,0,.71-.06,1.01-.17.3-.11.56-.27.78-.46.21-.2.37-.44.49-.72.12-.28.17-.59.17-.92,0-.68-.23-1.21-.68-1.59-.45-.39-1.11-.58-1.98-.58-.14,0-.29,0-.44,0-.15,0-.31.01-.46.02-.15,0-.31.01-.46.02-.14,0-.28.02-.4.04l.36-5.21h4.8v1.07h-3.78l-.21,3.05c.15,0,.32-.02.49-.02.17,0,.33-.01.46-.01.55,0,1.04.07,1.48.22.43.14.8.35,1.1.62.3.27.53.59.69.99.16.39.24.82.24,1.3Z" />
				<path d="m330.06,318.37v3.24h-1.05v-3.24h1.05Zm2.41,0v3.24h-1.05v-3.24h1.05Z" />
				<path d="m279.34,783.7l-2.35,8.33h-1.14l-1.71-6.09c-.07-.26-.12-.54-.13-.85h-.02c-.02.29-.07.57-.15.84l-1.72,6.1h-1.13l-2.44-8.33h1.07l1.77,6.39c.07.27.12.55.14.84h.03c.02-.21.08-.48.18-.84l1.84-6.39h.93l1.77,6.43c.06.22.11.48.14.78h.02c.02-.2.07-.47.16-.8l1.7-6.41h1.06Z" />
				<polygon points="284.19 783.7 280.2 793.41 279.31 793.41 283.29 783.7 284.19 783.7" />
				<path d="m285.16,792.03v-8.33h2.3c2.93,0,4.4,1.35,4.4,4.06,0,1.29-.41,2.32-1.23,3.1-.81.78-1.9,1.17-3.27,1.17h-2.21Zm.98-7.44v6.56h1.24c1.09,0,1.94-.29,2.55-.88.61-.58.91-1.41.91-2.49,0-2.13-1.13-3.2-3.4-3.2h-1.3Z" />
			</g>
		</g>
	)
}

export default PlanBB
